<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import required from "vuelidate/lib/validators/required";
import MaskedInput from "vue-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import DatePicker from "vue2-datepicker";
import cloneDeep from "lodash/cloneDeep";
import Warehouse from "@/components/modals/property-warehouse.vue";
import Employee from "@/components/modals/employee.vue";
import ItemCategory from "@/components/modals/item-category.vue";
import Unit from "@/components/modals/unit.vue";
import Contract from "@/components/modals/contract-history.vue";
import PO from "@/components/modals/purchase-order.vue";
import PoSearch from "@/components/modals/purchase-order-search.vue";
import UploadPopover from "@/components/widgets/upload-popover.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import RawData from "@/components/widgets/raw-data.vue";

export default {
  page: {
    title: "IAR"
  },
  components: {
    Layout,
    PageHeader,
    MaskedInput,
    DatePicker,
    Warehouse,
    Employee,
    ItemCategory,
    Unit,
    Contract,
    PO,
    PoSearch,
    UploadPopover,
    PrintOptions,
    RawData
  },
  data() {
    return {
      title: "Inspection",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Inspection",
          active: true
        }
      ],
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true
      }),
      quantityMask: createNumberMask({
        prefix: "",
        includeThousandsSeparator: false
      }),
      modalTitle: "",
      totalRows: 1,
      tableData: [],
      backupData: {},
      dateFilter: "",
      dateRangeIndex: -1,
      filter: "",
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      loading: false,
      campusId: this.$store.state.data.selectedCampus.id,
      cycle: this.$store.state.data.cycle,
      form: {
        id: null,
        poNumber: "",
        supplier: "",
        poId: null,
        iarNumber: "",
        dateOfDelivery: "",
        dateInspected: "",
        acceptanceDate: "",
        drNumber: "",
        cycle: "",
        supplySignatoryId: null,
        supplySignatoryName: "",
        supplySignatoryPosition: "",
        inspectionHeadId: null,
        inspectionHeadName: "",
        iarItems: []
      },
      iarForm: {
        id: null,
        iarNumber: ""
      },
      iarPage: 1,
      iarPagination: 1,
      generateIAR: true,
      minDate: "",
      maxDate: "",
      tabIndex: 0,
      update: 0,
      mouseOverSearch: false,
      viewOnly: false,
      cycleOptions: [],
      isAdmin: this.$store.state.decrypt.isAdmin(),
      token: this.$store.state.decrypt.getToken(),
      uploadOptions: {
        type: "IAR",
        placement: "lefttop",
        folder: "IAR"
      }
    };
  },
  validations: {
    form: {
      drNumber: { required },
      iarDate: { required },
      dateInspected: { required }
    }
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (
        this.dateFilter != null &&
        this.dateFilter != "" &&
        this.dateFilter[0] != null &&
        this.dateFilter[1] != null
      ) {
        data = data.filter((item) => {
          if (item.iarDate) {
            return (
              new Date(item.iarDate) >=
              new Date(this.dateFilter[0]) &&
              new Date(item.iarDate) <=
              new Date(this.dateFilter[1])
            );
          }
        });
      }
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (item.iarNumber.toUpperCase().includes(this.filter.toUpperCase()))
            return item.iarNumber
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          else if (item.poId) {
            if (
              item.poNumber.toUpperCase().includes(this.filter.toUpperCase())
            ) {
              return item.poNumber
                .toUpperCase()
                .includes(this.filter.toUpperCase());
            }
          }
        });
      }
      return data;
    },
    paginated() {
      let data = this.filtered;
      var total = this.currentPage * this.perPage;
      var currentData = data.slice(total - this.perPage, total);
      if (this.currentPage > 1 && currentData.length == 0) {
        total = (this.currentPage - 1) * this.perPage;
        currentData = data.slice(total - this.perPage, total);
      }
      return currentData;
    },
    rows() {
      return this.filtered.length;
    }
  },
  created() {
    this.changeCampus(this.$store.state.data.selectedCampus);
    if (this.$store.state.decrypt.isAdmin()) {
      this.viewOnly = false;
    } else {
      let accessList = this.$store.state.decrypt.userAccessList();
      let access = accessList.find(
        (x) =>
          x.Access.toLowerCase() === "manage inspection" &&
          x.Type.toLowerCase() === "inspection"
      );
      if (access) {
        this.viewOnly = false;
      } else {
        this.viewOnly = true;
      }
    }
  },
  methods: {
    changeCampus(campus) {
      this.cycle = this.$store.state.data.cycle;
      this.campusId = campus.id;
      if (this.tabIndex == 0) {
        this.getPending();
      } else if (this.tabIndex == 1) {
        this.getPosted();
      } else if (this.tabIndex == 2) {
        this.getCompleted();
      }
    },
    changeDU(du) {
      this.cycle = this.$store.state.data.cycle;
      this.campusId = du.campusId;
      if (this.tabIndex == 0) {
        this.getPending();
      } else if (this.tabIndex == 1) {
        this.getPosted();
      } else if (this.tabIndex == 2) {
        this.getCompleted();
      }
    },
    changeCycle(cycle) {
      this.cycle = cycle;
      this.campusId = this.$store.state.data.selectedDU.campusId;
      if (this.tabIndex == 0) {
        this.getPending();
      } else if (this.tabIndex == 1) {
        this.getPosted();
      } else if (this.tabIndex == 2) {
        this.getCompleted();
      }
    },
    getPending() {
      this.loading = true;
      let cycle = this.cycle;
      let campusId = this.campusId;
      this.$store
        .dispatch("inspectioniar/GetInspectionIarPendingSummary", {
          cycle,
          campusId
        })
        .then((res) => {
          res.data.forEach((x) => {
            x.visible = false;
            x.editIAR = false;
            x.iarNumberEdit = "";
            x.editDR = false;
            x.drNumberEdit = "";
            x.iarFiles = [];
            x.viewFile = false;
            x.addDocu = false;
            x.attachmentLoading = false;
            x.isWaived = false;
            x.iarItems = [];
          });
          this.tableData = res.data.sort(function (a, b) {
            return b.iarDate.localeCompare(a.iarDate);
          });
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting deliveries!",
              "error"
            );
          }
          this.loading = false;
        });
    },
    getPosted() {
      this.loading = true;
      let cycle = this.cycle;
      let campusId = this.campusId;
      this.$store
        .dispatch("inspectioniar/GetInspectionIarPostedSummary", {
          cycle,
          campusId
        })
        .then((res) => {
          res.data.forEach((x) => {
            x.visible = false;
            x.editIAR = false;
            x.iarNumberEdit = "";
            x.editDR = false;
            x.drNumberEdit = "";
            x.iarFiles = [];
            x.viewFile = false;
            x.addDocu = false;
            x.attachmentLoading = false;
            x.iarItems = [];
          });
          this.tableData = res.data.sort(function (a, b) {
            return b.iarDate.localeCompare(a.iarDate);
          });
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast("Something went wrong - Getting IAR!", "error");
          }
          this.loading = false;
        });
    },
    getCompleted() {
      this.loading = true;
      let cycle = this.cycle;
      let campusId = this.campusId;
      this.$store
        .dispatch("inspectioniar/GetInspectionIarCompletedSummary", {
          cycle,
          campusId
        })
        .then((res) => {
          res.data.forEach((x) => {
            x.visible = false;
            x.editIAR = false;
            x.iarNumberEdit = "";
            x.editDR = false;
            x.drNumberEdit = "";
            x.iarFiles = [];
            x.viewFile = false;
            x.addDocu = false;
            x.attachmentLoading = false;
            x.iarItems = [];
          });
          this.tableData = res.data.reverse();
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting Completed IAR!",
              "error"
            );
          }
          this.loading = false;
        });
    },
    getIarItems(props) {
      props.visible = !props.visible;
      if (props.visible) {
        this.$store
          .dispatch("inspectioniar/GetInspectionIarItems", props.id)
          .then((res) => {
            if (this.tabIndex == 0) {
              var count = 0;
              res.data.forEach((item) => {
                if (!item.isDelivered) count++;
              });
              if (count == res.data.length) props.isWaived = true;
            }
            props.iarItems = res.data.sort(function (a, b) {
              if (!a.itemName) {
                return -1;
              }
              if (!b.itemName) {
                return +1;
              }
              return a.itemName.localeCompare(b.itemName);
            });
          })
          .catch((err) => {
            let stringErr = err.toString();
            if (stringErr.includes("Network")) {
              this.showToast("Network Error!", "error");
            } else {
              this.showToast("Something went wrong - IAR Items!", "error");
            }
          });
      }
    },
    selectDate(type) {
      if (type == "Today") {
        this.dateRangeIndex = 0;
        this.$refs.dateFilter.currentValue = [new Date(), new Date()];
        this.$refs.dateFilter.handleConfirmDate();
      } else if (type == "Yesterday") {
        this.$refs.dateFilter.currentValue = [
          new Date(Date.now() - 3600 * 1000 * 24),
          new Date(Date.now() - 3600 * 1000 * 24)
        ];
        this.dateRangeIndex = 1;
        this.$refs.dateFilter.handleConfirmDate();
      } else if (type == "Last 7 Days") {
        this.$refs.dateFilter.currentValue = [
          new Date(Date.now() - 7 * 24 * 3600 * 1000),
          new Date()
        ];
        this.dateRangeIndex = 2;
        this.$refs.dateFilter.handleConfirmDate();
      } else if (type == "This Month") {
        this.$refs.dateFilter.currentValue = [
          new Date(new Date().getFullYear(), new Date().getMonth(), 1),
          new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
        ];
        this.dateRangeIndex = 3;
        if (this.$refs.dateFilter)
          this.$refs.dateFilter.handleConfirmDate();
      } else if (type == "This Year") {
        this.$refs.dateFilter.currentValue = [
          new Date(new Date().getFullYear(), 0, 1),
          new Date(new Date().getFullYear() + 1, 0, 0)
        ];
        this.dateRangeIndex = 4;
        this.$refs.dateFilter.handleConfirmDate();
      } else if (type == "Custom") {
        this.dateRangeIndex = 5;
      }
    },
    checkDateFilter() {
      if (
        this.dateFilter[0] == null &&
        this.dateFilter[1] == null
      ) {
        this.dateFilter = "";
        this.dateRangeIndex = -1;
      }
    },
    onCreateDelivery() {
      this.submitted = true;
      if (
        this.form.dateOfDelivery == "" ||
        this.form.acceptanceDate == "" ||
        this.form.drNumber == "" ||
        this.form.cycle == ""
      ) {
        return;
      } else {
        this.form.dateOfDelivery = this.getDate(this.form.dateOfDelivery);
        this.form.acceptanceDate = this.getDate(this.form.acceptanceDate);
        this.form.dateInspected = "0001-01-01T00:00:00";
        this.form.iarDate = new Date();
        this.form.createAndPost = false;
        this.form.sendEmail = false;
        this.form.poId = 0;
        this.form.iarItems.forEach((item) => {
          item.quantity = this.getExactAmt(item.quantity);
          item.unitCost = this.getExactAmt(item.unitCost);
        });
        this.$store
          .dispatch("inspectioniar/CreateInspectionIar", this.form)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            this.getPending();
            this.$bvModal.hide("modal-create");
            this.showToast("Successfully created!", "success");
          })
          .catch((err) => {
            this.showToast(
              "Something went wrong - Creating Delivery!",
              "error"
            );
          });
        this.submitted = false;
      }
    },
    createDelivery() {
      this.onReset();
      this.form.iarItems = [
        {
          rfqSupplierOfferId: 0,
          itemName: "",
          description: "",
          brand: "",
          model: "",
          specification: "",
          color: "",
          dimensionDescription: "",
          materialUsed: "",
          packageDescription: "",
          condition: "",
          quantity: "",
          unitId: 0,
          itemCategoryId: 0,
          unitCost: "",
          warrantyStartDate: "",
          warrantyEndDate: "",
          isDelivered: true,
          locationAreaId: 0,
          notes: "",
          locationAreaName: "",
          itemCategoryName: "",
          unitName: ""
        }
      ];
      this.modalTitle = "Create Delivery";
      this.$bvModal.show("modal-create");
    },
    onMergeStock() {
      let iarItems = this.form.iarItems.filter((item) => {
        return item.stockItemId != null;
      });
      let stockData = [];
      iarItems.forEach((item) => {
        stockData.push({
          stockItemId: item.stockItemId,
          description: this.form.po.description,
          debit: item.quantity,
          credit: 0,
          unitCost: item.unitCost,
          referenceNumber: this.form.po.poNumber,
          iarItemId: item.id,
          deliveryUnitId: 0,
          stockItemTransactionParentId: 0,
          status: "POSTED"
        });
      });
      this.$store
        .dispatch("stock/CreateMultipleStockTransaction", stockData)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          stockData.forEach((item) => {
            this.$store.dispatch("propertyiar/PostPropertyIar", item.iarItemId);
          });
        });
    },
    onPost() {
      this.$store
        .dispatch("inspectioniar/PostInspectionIar", this.form)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          var index = this.tableData.findIndex(
            (item) => item.id == this.form.id
          );
          this.tableData.splice(index, 1);
          this.$bvModal.hide("modal-post");
          let dashboardData = JSON.parse(localStorage.getItem("dashboardData"));
          dashboardData.needRequisitionAssign =
            dashboardData.needRequisitionAssign + 1;
          localStorage.setItem("dashboardData", JSON.stringify(dashboardData));
          this.showToast("Successfully posted!", "success");
          this.onReset();
        })
        .catch((err) => {
          this.showToast("Something went wrong - Posting IAR!", "error");
        });
    },
    onCreate() {
      this.submitted = true;
      this.$v.$touch();
      if (
        this.$v.$invalid ||
        (!this.generateIAR && this.form.iarNumber == "")
      ) {
        return;
      } else {
        this.form.dateInspected = this.getDate(this.form.dateInspected);
        this.form.iarDate = this.getDate(this.form.iarDate);
        this.form.iarItems.forEach((item) => {
          item.unitCost = this.getExactAmt(item.unitCost);
        });
        this.form.iarNumber = this.generateIAR ? "" : this.form.iarNumber;
        this.$store
          .dispatch("inspectioniar/UpdateInspectionIar", this.form)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            this.onPost();
          })
          .catch((err) => {
            this.showToast("Something went wrong - Posting IAR!", "error");
          });
        this.submitted = false;
      }
    },
    postIar(props) {
      this.onReset();
      this.form = cloneDeep(props);
      this.form.cycle = this.cycle;
      this.form.dateInspected = new Date();
      this.form.iarDate = new Date();
      this.form.supplySignatoryName = props.supplySignatory
        ? props.supplySignatory
        : "";
      this.form.inspectionHeadName = props.inspectionHead
        ? props.inspectionHead
        : "";
      // this.form.iarItems = this.form.iarItems.filter((item) => {
      //   return item.isDelivered;
      // });
      // this.form.iarItems.forEach((item) => {
      //   item.unitCost = item.unitCost.toString();
      //   item.total = item.total.toString();
      //   item.warrantyStartDate = "";
      //   item.warrantyEndDate = "";
      //   item.locationAreaName = "";
      //   item.itemCategoryName = item.itemCategory.name;
      //   item.unitName = item.unit.unitName;
      // });
      this.modalTitle = "Create IAR";
      this.$bvModal.show("modal-post");
    },
    onPostWaived() {
      this.submitted = true;
      if (
        this.form.dateInspected == "" ||
        (!this.generateIAR && this.form.iarNumber == "")
      ) {
        return;
      } else {
        this.form.dateInspected = this.getDate(this.form.dateInspected);
        this.form.iarNumber = this.generateIAR ? "" : this.form.iarNumber;
        this.$store
          .dispatch("inspectioniar/UpdateInspectionIar", this.form)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            this.$store
              .dispatch("inspectioniar/PostInspectionIar", this.form)
              .then((res) => {
                if (res.data.error) {
                  return this.showToast(res.data.errorMessage, "error");
                }
                var index = this.tableData.findIndex(
                  (item) => item.id == this.form.id
                );
                this.tableData.splice(index, 1);
                this.showToast("Successfully posted!", "success");
                this.$bvModal.hide("modal-post-waived");
              })
              .catch((err) => {
                this.showToast("Something went wrong - Posting IAR!", "error");
              });
          });
        this.submitted = false;
      }
    },
    postWaived(props) {
      this.onReset();
      this.form = cloneDeep(props);
      this.form.cycle = this.cycle;
      this.form.iarDate = new Date();
      this.form.dateInspected = new Date();
      this.modalTitle = "Create IAR";
      this.$bvModal.show("modal-post-waived");
    },
    unpostIar(props) {
      var index = this.tableData.indexOf(props);
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, undo!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("inspectioniar/UnpostInspectionIar", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.tableData.splice(index, 1);
              this.showToast(
                "Successfully returned to delivery list.",
                "success"
              );
            })
            .catch((err) => {
              this.showToast("Cannot be returned!", "error");
            });
        }
      });
    },
    onUpdate() {
      this.submitted = true;
      if (
        (!this.form.isWaived &&
          ((this.form.dateOfDelivery == "" || this.form.dateOfDelivery == null) || (this.form.drNumber == "" || this.form.drNumber == null) || (this.tabIndex == 1 && (this.form.dateInspected == "" || this.form.dateInspected == null)))) ||
        (this.form.isWaived && (this.form.dateOfDelivery == "" || this.form.dateOfDelivery == null))
      ) {
        return;
      } else {
        this.form.dateOfDelivery =
          this.form.dateOfDelivery != ""
            ? this.getDate(this.form.dateOfDelivery)
            : "0001-01-01T00:00:00";
        this.form.acceptanceDate =
          this.form.acceptanceDate != ""
            ? this.getDate(this.form.acceptanceDate)
            : "0001-01-01T00:00:00";
        this.form.dateInspected =
          this.form.dateInspected != ""
            ? this.getDate(this.form.dateInspected)
            : "0001-01-01T00:00:00";
        this.$store
          .dispatch("inspectioniar/UpdateInspectionIar", this.form)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            var index = this.tableData.findIndex(
              (item) => item.id == this.form.id
            );
            this.tableData[index].visible = true;
            this.tableData[index].dateOfDelivery = this.form.dateOfDelivery;
            this.tableData[index].acceptanceDate = this.form.acceptanceDate;
            this.tableData[index].dateInspected = this.form.dateInspected;
            this.tableData[index].drNumber = this.form.drNumber;
            this.tableData[
              index
            ].supplySignatoryId = this.form.supplySignatoryId;
            this.tableData[
              index
            ].supplySignatoryPosition = this.form.supplySignatoryPosition;
            this.tableData[index].inspectionHeadId = this.form.inspectionHeadId;
            if (this.tableData[index].supplySignatory)
              this.tableData[
                index
              ].supplySignatory = this.form.supplySignatoryName;
            if (this.tableData[index].inspectionHead)
              this.tableData[
                index
              ].inspectionHead = this.form.inspectionHeadName;
            this.$bvModal.hide("modal-update");
          })
          .catch((err) => {
            this.showToast("Something went wrong - Updating IAR!", "error");
          });
        this.submitted = false;
      }
    },
    updateIar(props) {
      this.submitted = false;
      this.form = cloneDeep(props);
      this.form.cycle = this.cycle;
      this.form.dateOfDelivery = this.form.dateOfDelivery.includes("0001-01-01")
        ? ""
        : new Date(this.form.dateOfDelivery);
      this.form.acceptanceDate = this.form.acceptanceDate.includes("0001-01-01")
        ? ""
        : new Date(this.form.acceptanceDate);
      this.form.dateInspected = this.form.dateInspected.includes("0001-01-01")
        ? ""
        : new Date(this.form.dateInspected);
      this.form.supplySignatoryName = props.supplySignatory
        ? props.supplySignatory
        : "";
      this.form.inspectionHeadName = props.inspectionHead
        ? props.inspectionHead
        : "";
      this.modalTitle =
        this.tabIndex == 0 ? "Update Delivery Details" : "Update IAR Details";
      this.$bvModal.show("modal-update");
    },
    onUpdateIarNumber(props) {
      this.submitted = true;
      if (props.iarNumberEdit == "") {
        return;
      } else {
        this.$store
          .dispatch("inspectioniar/UpdateIarNumber", {
            id: props.id,
            body: props.iarNumberEdit
          })
          .then((res) => {
            if (res.data.error) {
              this.showToast(
                "Cannot update info. " + res.data.errorMessage,
                "error"
              );
              return;
            }
            props.iarNumber = cloneDeep(props.iarNumberEdit);
            props.editIAR = false;
            this.showToast("IAR Number updated successfully", "success");
          })
          .catch((error) => {
            this.showToast("Something went wrong.", "error");
          });
        this.submitted = false;
      }
    },
    updateIarNumber(props) {
      props.editIAR = true;
      props.iarNumberEdit = cloneDeep(props.iarNumber);
    },
    deleteIar(props) {
      var index = this.tableData.indexOf(props);
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, return it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("inspectioniar/DeleteInspectionIar", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.tableData.splice(index, 1);
              this.showToast("Successfully returned", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be returned!", "error");
            });
        }
      });
    },
    onUpdateDRNumber(props) {
      this.submitted = true;
      if (props.drNumberEdit == "") {
        return;
      } else {
        this.$store
          .dispatch("inspectioniar/UpdateDRNumber", {
            id: props.id,
            drNumber: props.drNumberEdit
          })
          .then((res) => {
            if (res.data.error) {
              this.showToast(
                "Cannot update info. " + res.data.errorMessage,
                "error"
              );
              return;
            }
            props.drNumber = cloneDeep(props.drNumberEdit);
            props.editDR = false;
            this.showToast("D.R. updated successfully", "success");
          })
          .catch((error) => {
            this.showToast("Something went wrong.", "error");
          });
        this.submitted = false;
      }
    },
    updateDRNumber(props) {
      props.editDR = true;
      props.drNumberEdit = cloneDeep(props.drNumber);
    },
    sendEmail(props) {
      this.$swal({
        title: "Are you sure?",
        text:
          "You are about to send an email to COA to notify the items partial/full delivery.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Send Email!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("inspectioniar/SendEmailToCOA", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.showToast("Email sent!", "success");
            })
            .catch((err) => {
              this.showToast("Email not sent!", "error");
            });
        }
      });
    },
    onReset() {
      this.form = {
        id: null,
        poNumber: "",
        supplier: "",
        poId: null,
        iarNumber: "",
        dateOfDelivery: "",
        dateInspected: "",
        acceptanceDate: "",
        drNumber: "",
        cycle: "",
        supplySignatoryId: null,
        supplySignatoryName: "",
        supplySignatoryPosition: "",
        inspectionHeadId: null,
        inspectionHeadName: "",
        iarItems: []
      };
      this.iarPage = 1;
      this.iarPagination = 1;
      this.generateIAR = true;
      this.minDate = "";
      this.maxDate = "";
      this.getCycleOptions();
    },
    getSuspension(poId) {
      this.$store
        .dispatch("po/GetSinglePo", poId)
        .then((res) => {
          this.$refs.contract.getSuspension(res.data, "IAR");
          this.$bvModal.show("modal-contract");
        })
        .catch(() => {
          this.showToast("Something went wrong - getting contract", "error");
          this.loading = false;
        });
    },
    getPO(row) {
      this.$refs.po.getData(row.poId);
      this.$bvModal.show("po-modal");
    },
    addIarItem(page, item) {
      if (this.checkCreateForm(item)) {
        this.form.iarItems.push({
          rfqSupplierOfferId: 0,
          itemName: "",
          description: "",
          brand: "",
          model: "",
          specification: "",
          color: "",
          dimensionDescription: "",
          materialUsed: "",
          packageDescription: "",
          condition: "",
          quantity: "",
          unitId: 0,
          itemCategoryId: 0,
          unitCost: "",
          warrantyStartDate: "",
          warrantyEndDate: "",
          isDelivered: true,
          locationAreaId: 0,
          notes: "",
          locationAreaName: "",
          itemCategoryName: "",
          unitName: ""
        });
        this.iarPage = page;
        this.iarPagination = page;
      }
      this.$forceUpdate();
    },
    removeIarItem(page) {
      this.form.iarItems.splice(page, 1);
      this.iarPage = page;
      this.iarPagination = page;
      this.$forceUpdate();
    },
    changeIarPage(page, item) {
      if (!item || this.checkCreateForm(item)) {
        this.iarPage = page;
        this.iarPagination = page;
      } else {
        this.iarPagination = this.iarPage;
      }
      this.$forceUpdate();
    },
    checkCreateForm(item) {
      this.submitted = true;
      if (
        item.itemName == "" ||
        item.itemName == null ||
        item.condition == "" ||
        item.condition == null ||
        item.itemCategoryId == "" ||
        item.itemCategoryId == null ||
        item.unitId == "" ||
        item.unitId == null ||
        item.quantity == "" ||
        item.quantity == null ||
        item.unitCost == "" ||
        item.unitCost == null ||
        (item.warrantyStartDate != "" &&
          item.warrantyStartDate != null &&
          (item.warrantyEndDate == "" || item.warrantyEndDate == null))
      ) {
        this.showToast(
          "Please ensure that all required fields are filled.",
          "warning"
        );
        return false;
      } else {
        item.warrantyStartDate =
          item.warrantyStartDate != "" && item.warrantyStartDate != null
            ? this.getDate(item.warrantyStartDate)
            : "0001-01-01T00:00:00";
        item.warrantyEndDate =
          item.warrantyEndDate != "" && item.warrantyEndDate != null
            ? this.getDate(item.warrantyEndDate)
            : "0001-01-01T00:00:00";
        this.minDate = "";
        this.maxDate = "";
        this.submitted = false;
        return true;
      }
    },
    getEmployee(type) {
      this.employeeType = type;
      this.$refs.employee.getSingleSelection();
      this.$bvModal.show("employee-modal");
    },
    dropEmployee(employee) {
      if (this.employeeType == "inspection") {
        this.form.inspectionHeadId = employee.applicationUser.id;
        this.form.inspectionHeadName = employee.applicationUser.completeName;
        this.$forceUpdate();
      } else {
        this.form.supplySignatoryId = employee.applicationUser.id;
        this.form.supplySignatoryName = employee.applicationUser.completeName;
        this.$forceUpdate();
      }
    },
    removeEmployee(type) {
      if (type == "inspection") {
        this.form.inspectionHeadId = null;
        this.form.inspectionHeadName = "";
        this.$forceUpdate();
      } else {
        this.form.supplySignatoryId = null;
        this.form.supplySignatoryName = "";
        this.$forceUpdate();
      }
    },
    getWarehouse(props) {
      this.itemIndex = this.form.iarItems.indexOf(props);
      this.$refs.warehouse.getData(this.campusId);
      this.$bvModal.show("warehouse-modal");
    },
    dropWarehouse(data) {
      this.form.iarItems[this.itemIndex].locationAreaId = data.id;
      this.form.iarItems[this.itemIndex].locationAreaName = data.areaName;
      this.$forceUpdate();
    },
    removeWarehouse(props) {
      this.itemIndex = this.form.iarItems.indexOf(props);
      this.form.iarItems[this.itemIndex].locationAreaId = 0;
      this.form.iarItems[this.itemIndex].locationAreaName = "";
    },
    getItemCategory(props) {
      this.itemIndex = this.form.iarItems.indexOf(props);
      this.$bvModal.show("item-category-modal");
    },
    dropItemCat(data) {
      this.form.iarItems[this.itemIndex].itemCategoryId = data.id;
      this.form.iarItems[this.itemIndex].itemCategoryName = data.name;
      this.$forceUpdate();
    },
    getUnit(props) {
      this.itemIndex = this.form.iarItems.indexOf(props);
      this.$refs.unit.getData();
      this.$bvModal.show("unit-modal");
    },
    dropUnit(data) {
      this.form.iarItems[this.itemIndex].unitId = data.id;
      this.form.iarItems[this.itemIndex].unitName = data.unitName;
      this.$forceUpdate();
    },
    getTotal(array) {
      var total = 0;
      array.forEach((item) => {
        if (item.isDelivered) {
          total = total + item.unitCost * item.quantity;
        }
      });
      return total;
    },
    checkMax(qty, max) {
      if (qty != null && max != null) {
        if (parseFloat(qty) < 1 || parseFloat(qty) > parseFloat(max))
          return true;
        else return false;
      }
    },
    setRange(dateFrom, dateTo) {
      this.minDate = dateFrom != "" ? new Date(dateFrom) : "";
      this.maxDate = dateTo != "" ? new Date(dateTo) : "";
    },
    disabledRangeFrom(date) {
      if (this.maxDate != "") return date > new Date(this.maxDate);
    },
    disabledRangeTo(date) {
      if (this.minDate != "") return date < new Date(this.minDate);
    },
    async getAttachments(row) {
      row.viewFile = true;
      row.iarFiles = [];
      row.attachmentLoading = true;
      await this.$store
        .dispatch("filemanager/GetFiles", {
          id: row.id,
          type: "IAR"
        })
        .then((res) => {
          res.data.forEach((item) => {
            row.iarFiles.push(item);
          });
        })
        .catch(() => {
          this.showToast("Something went wrong! - getting documents", "error");
        });
      await this.$store
        .dispatch("filemanager/GetFiles", {
          id: row.poId,
          type: "Purchase Order"
        })
        .then((res) => {
          res.data.forEach((item) => {
            row.iarFiles.push(item);
          });
        })
        .catch(() => {
          this.showToast("Something went wrong! - getting documents", "error");
        });
      row.attachmentLoading = false;
    },
    openDocument(x) {
      this.readFile(x.id);
    },
    removeFile(id, iarId) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("filemanager/DeleteFile", id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let iarIndex = this.tableData.findIndex(
                (item) => item.id == iarId
              );
              let fileIndex = this.tableData[iarIndex].iarFiles.findIndex(
                (item) => item.id == id
              );
              this.tableData[iarIndex].iarFiles.splice(fileIndex, 1);
              this.showToast("Successfully removed!", "success");
            })
            .catch(() => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    uploadedFiles() { },
    async printNoticeOFDelivery(iarId) {
      var apiUrl = `api/Report/Inspection/Notice`;
      var routeVariables = [iarId];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables
      });
      this.$bvModal.show("print-options-modal");
    },
    async printDelay(poId) {
      var apiUrl = `api/Report/Inspection/Delay`;
      var routeVariables = [poId];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables
      });
      this.$bvModal.show("print-options-modal");
    },
    async printIar(iarId) {
      var apiUrl = `api/Report/Inspection/IAR`;
      var routeVariables = [iarId];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables
      });
      this.$bvModal.show("print-options-modal");
    },
    async printDeliveryHistory(poId) {
      var apiUrl = `api/Report/Inspection/Delivery/History`;
      var routeVariables = [poId];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables
      });
      this.$bvModal.show("print-options-modal");
    },
    searchPo() {
      this.$refs.PoSearch.resetData();
      this.$bvModal.show("po-search-modal");
    },
    checkDate(date) {
      if (date.includes("0001-01-01")) return false;
      else return true;
    },
    getCycleOptions() {
      var cycles = [{ text: "", value: 0 }];
      this.$store.dispatch("cycle/GetAllCycle").then((res) => {
        res.data.forEach((item) => {
          cycles.push({ value: item.year, text: item.year });
        });
        this.cycleOptions = cycles;
      });
    }
  }
};
</script>
<template>
  <Layout @changeCampus="changeCampus" @changeDU="changeDU" @changeCycle="changeCycle">
    <PageHeader :title="title" :items="items" />
    <!-- Create IAR -->
    <b-modal id="modal-create" :title="modalTitle" size="xl" title-class="font-18" hide-footer no-close-on-backdrop>
      <div v-if="modalTitle == 'Create Delivery'" class="mb-3">
        <div class="d-flex align-items-end justify-content-between mb-3">
          <div class="font-size-16">
            <b v-if="iarPage == form.iarItems.length + 1">Create Delivery</b>
            <div v-else>Item {{ iarPage }} of {{ form.iarItems.length }}</div>
          </div>
          <div>
            <div class="dataTables_paginate paging_simple_numbers float-end"
              @click="changeIarPage(iarPagination, form.iarItems[iarPage - 1])">
              <ul class="paginate pagination mb-0">
                <b-pagination v-model="iarPagination" :total-rows="form.iarItems.length + 1" :per-page="1">
                  <template #last-text><i class="bx bxs-flag-alt"></i></template>
                  <template #page="{ page }">
                    <div v-if="page == form.iarItems.length + 1">
                      <i class="bx bxs-flag-alt"></i>
                    </div>
                    <div v-else>{{ page }}</div>
                  </template>
                </b-pagination>
              </ul>
            </div>
          </div>
        </div>
        <div v-for="(x, index) in form.iarItems" :key="x.id">
          <div v-if="index + 1 == iarPage">
            <b-card-body class="border">
              <div class="d-flex flex-row-reverse gap-1">
                <button class="btn btn-sm btn-info" @click="addIarItem(iarPage + 1, x)">
                  <i class="mdi mdi-plus me-1"></i>Add Item
                </button>
                <button v-if="form.iarItems.length > 1" class="btn btn-sm btn-danger"
                  @click="removeIarItem(iarPage - 1)">
                  <i class="mdi mdi-trash-can me-1"></i>Remove
                </button>
              </div>
              <div class="mb-3">
                <label for="itemName">Name </label>
                <input id="itemName" type="text" v-model="x.itemName" placeholder="Enter Name..." class="form-control"
                  :class="{
                    'is-invalid':
                      submitted && (x.itemName === '' || x.itemName === null)
                  }" autocomplete="off" />
                <div v-if="submitted && (x.itemName === '' || x.itemName === null)" class="invalid-feedback">
                  <span>This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-6">
                    <label for="quantity">Quantity </label>
                    <masked-input id="quantity" type="text" v-model="x.quantity" placeholder="Enter quantity..."
                      class="form-control" :class="{
                        'is-invalid':
                          submitted &&
                          (x.quantity === '' ||
                            x.quantity === '0' ||
                            x.quantity === null)
                      }" :mask="quantityMask" autocomplete="off"></masked-input>
                    <div v-if="
                      submitted &&
                      (x.quantity === '' ||
                        x.quantity === '0' ||
                        x.quantity === null)
                    " class="invalid-feedback">
                      <span>This value is required.</span>
                    </div>
                  </div>
                  <div class="col-6">
                    <label for="unitCost">Unit Cost </label>
                    <masked-input id="unitCost" type="text" v-model="x.unitCost" placeholder="Enter unitCost..."
                      class="form-control" :class="{
                        'is-invalid':
                          submitted &&
                          (x.unitCost === '' || x.unitCost === null)
                      }" :mask="currencyMask" autocomplete="off"></masked-input>
                    <div v-if="
                      submitted && (x.unitCost === '' || x.unitCost === null)
                    " class="invalid-feedback">
                      <span>This value is required.</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <label for="locationAreaId">Warehouse Location </label>
                <b-input-group>
                  <template #append>
                    <b-button @click="getWarehouse(x)" variant="outline-info"><i
                        class="mdi mdi-clipboard-text-search-outline"></i></b-button>
                  </template>
                  <input autocomplete="off" type="text" disabled placeholder="Search Warehouse Location..."
                    class="form-control" :class="{
                      'is-invalid':
                        submitted &&
                        (x.locationAreaId === '' || x.locationAreaId === null)
                    }" v-model="x.locationAreaName" />
                </b-input-group>
                <div v-if="
                  submitted &&
                  (x.locationAreaId === '' || x.locationAreaId === null)
                " class="invalid-feedback">
                  <span>This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="dateExpected">Warranty Date </label>
                <div class="row">
                  <div class="col-6" @click="setRange(x.warrantyStartDate, x.warrantyEndDate)">
                    <date-picker v-model="x.warrantyStartDate" lang="en" @input="$forceUpdate()"
                      :disabled-date="disabledRangeFrom" placeholder="Enter Warranty Start..."></date-picker>
                  </div>
                  <div class="col-6" @click="setRange(x.warrantyStartDate, x.warrantyEndDate)">
                    <date-picker v-model="x.warrantyEndDate" lang="en" @input="$forceUpdate()"
                      :disabled-date="disabledRangeTo" placeholder="Enter Warranty End..." :class="{
                        'is-invalid':
                          submitted &&
                          x.warrantyStartDate != '' &&
                          x.warrantyStartDate != null &&
                          (x.warrantyEndDate === '' ||
                            x.warrantyEndDate === null)
                      }"></date-picker>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <label for="unitId">Unit </label>
                <b-input-group>
                  <template #append>
                    <b-button @click="getUnit(x)" variant="outline-info"><i
                        class="mdi mdi-clipboard-text-search-outline"></i></b-button>
                  </template>
                  <input autocomplete="off" type="text" disabled placeholder="Search Unit..." class="form-control"
                    :class="{
                      'is-invalid':
                        submitted && (x.unitName === '' || x.unitName === null)
                    }" v-model="x.unitName" />
                </b-input-group>
                <div v-if="submitted && (x.unitName === '' || x.unitName === null)" class="invalid-feedback">
                  <span>This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="itemCategoryId">Item Category </label>
                <b-input-group>
                  <template #append>
                    <b-button @click="getItemCategory(x)" variant="outline-info"><i
                        class="mdi mdi-clipboard-text-search-outline"></i></b-button>
                  </template>
                  <input autocomplete="off" type="text" disabled placeholder="Search Item Category..."
                    class="form-control" :class="{
                      'is-invalid':
                        submitted &&
                        (x.itemCategoryName === '' ||
                          x.itemCategoryName === null)
                    }" v-model="x.itemCategoryName" />
                </b-input-group>
                <div v-if="
                  submitted &&
                  (x.itemCategoryName === '' || x.itemCategoryName === null)
                " class="invalid-feedback">
                  <span>This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="description">Description</label>
                <textarea id="description" rows="2" v-model="x.description" placeholder="Enter Description..."
                  class="form-control" autocomplete="off"></textarea>
              </div>
              <div class="row mb-3">
                <div class="col-md-8">
                  <label for="brand">Brand </label>
                  <input id="brand" type="text" v-model="x.brand" placeholder="Enter Brand..." class="form-control"
                    autocomplete="off" />
                </div>
                <div class="col-md-4">
                  <label for="model">Model </label>
                  <input id="model" type="text" v-model="x.model" placeholder="Enter Model..." class="form-control"
                    autocomplete="off" />
                </div>
              </div>
              <div class="mb-3">
                <label for="condition">Condition </label>
                <b-form-select class="form-select" :class="{
                  'is-invalid':
                    submitted && (x.condition === '' || x.condition === null)
                }" v-model="x.condition">
                  <b-form-select-option :value="null || ''" disabled>Select Condition...</b-form-select-option>
                  <b-form-select-option value="New">New</b-form-select-option>
                  <b-form-select-option value="Purchased">Purchased</b-form-select-option>
                  <b-form-select-option value="Used">Used</b-form-select-option>
                  <b-form-select-option value="Donated">Donated</b-form-select-option>
                  <b-form-select-option value="Refurbished">Refurbished</b-form-select-option>
                  <b-form-select-option value="Re-condition">Re-condition</b-form-select-option>
                </b-form-select>
                <div v-if="
                  submitted && (x.condition === '' || x.condition === null)
                " class="invalid-feedback">
                  <span>This value is required.</span>
                </div>
              </div>
              <div class="mb-3">
                <label for="specification">Specification </label>
                <textarea id="specification" rows="2" v-model="x.specification" placeholder="Enter Specification..."
                  class="form-control" autocomplete="off"></textarea>
              </div>
              <div class="row mb-3">
                <div class="col-md-4">
                  <label for="color">Color</label>
                  <input id="color" type="text" v-model="x.color" placeholder="Enter Color..." class="form-control"
                    autocomplete="off" />
                </div>
                <div class="col-md-8">
                  <label for="dimensionDescription">Dimension Description
                  </label>
                  <input id="dimensionDescription" type="text" v-model="x.dimensionDescription"
                    placeholder="Enter Dimension Description..." class="form-control" autocomplete="off" />
                </div>
              </div>
              <div class="mb-3">
                <label for="materialUsed">Material Used </label>
                <textarea id="materialUsed" rows="2" v-model="x.materialUsed" placeholder="Enter Material Used..."
                  class="form-control" autocomplete="off"></textarea>
              </div>
              <div class="mb-3">
                <label for="packageDescription">Package Description </label>
                <textarea id="packageDescription" rows="4" v-model="x.packageDescription"
                  placeholder="Enter Package Description..." class="form-control" autocomplete="off"></textarea>
              </div>
              <div class="mb-3">
                <label for="notes">Notes</label>
                <textarea id="notes" rows="2" v-model="x.notes" placeholder="Enter Notes..." class="form-control"
                  autocomplete="off"></textarea>
              </div>
            </b-card-body>
            <div class="row mt-3">
              <div class="col-3">
                <button v-if="iarPage > 1" class="btn btn-primary btn-block" @click="changeIarPage(iarPage - 1, x)">
                  Back
                </button>
              </div>
              <div class="col-5"></div>
              <div class="col-4">
                <button class="btn btn-success btn-block" @click="changeIarPage(iarPage + 1, x)">
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="iarPage == form.iarItems.length + 1">
          <b-card-body class="border">
            <div class="row mb-3">
              <div class="col-md-6">
                <label for="dateOfDelivery">Date of Delivery</label>
                <date-picker v-model="form.dateOfDelivery" lang="en" placeholder="Enter Date of Delivery..." :class="{
                  'is-invalid':
                    submitted &&
                    (form.dateOfDelivery == '' || form.dateOfDelivery == null)
                }"></date-picker>
                <div v-if="
                  submitted &&
                  (form.dateOfDelivery == '' || form.dateOfDelivery == null)
                " class="invalid-feedback">
                  <span>This value is required.</span>
                </div>
              </div>
              <div class="col-md-6">
                <label for="cycle">Cycle</label>
                <b-form-select id="cycle" v-model="form.cycle" :options="cycleOptions" class="form-select" :class="{
                  'is-invalid':
                    submitted && (form.cycle == '' || form.cycle == null)
                }"></b-form-select>
                <div v-if="submitted && (form.cycle == '' || form.cycle == null)" class="invalid-feedback">
                  <span>This value is required.</span>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-6">
                <label for="acceptanceDate">Acceptance Date</label>
                <date-picker v-model="form.acceptanceDate" lang="en" placeholder="Enter Date of Delivery..." :class="{
                  'is-invalid':
                    submitted &&
                    (form.acceptanceDate == '' || form.acceptanceDate == null)
                }"></date-picker>
                <div v-if="
                  submitted &&
                  (form.acceptanceDate == '' || form.acceptanceDate == null)
                " class="invalid-feedback">
                  <span>This value is required.</span>
                </div>
              </div>
              <div class="col-md-6">
                <label for="drNumber">Invoice Number / D.R. Number</label>
                <input id="drNumber" type="text" v-model="form.drNumber" placeholder="Enter Invoice/D.R. Number..."
                  class="form-control" :class="{
                    'is-invalid':
                      submitted &&
                      (form.drNumber == '' || form.drNumber == null)
                  }" autocomplete="off" />
                <div v-if="
                  submitted && (form.drNumber == '' || form.drNumber == null)
                " class="invalid-feedback">
                  <span>This value is required.</span>
                </div>
              </div>
            </div>
            <div class="mb-4">
              <table width="100%">
                <thead>
                  <tr class="border-bottom">
                    <th style="width: 90px" class="py-2">Qty</th>
                    <th class="py-2">Item Name</th>
                    <th class="py-2" style="width: 150px">Status</th>
                    <th class="py-2" style="width: 150px">Unit Price</th>
                    <th class="py-2" style="width: 150px">Total Price</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(y, index) in form.iarItems" :key="index" class="border-bottom">
                    <td class="py-2 align-top" v-if="y.id !== null">
                      {{ getExactAmt(y.quantity) }}
                    </td>
                    <td class="py-2 align-top" v-if="y.id !== null">
                      {{ y.itemName }}
                    </td>
                    <td class="py-2 align-top" v-if="y.id !== null">
                      <div :class="y.isDelivered ? 'text-success' : 'text-danger'">
                        {{ y.isDelivered ? "DELIVERED" : "WAIVED" }}
                      </div>
                    </td>
                    <td class="py-2 align-top text-warning" v-if="y.id !== null">
                      {{ formatCurrency(getExactAmt(y.unitCost)) }}
                    </td>
                    <td class="py-2 align-top text-warning" v-if="y.id !== null">
                      {{
                        formatCurrency(
                          getExactAmt(y.unitCost) * getExactAmt(y.quantity)
                        )
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-card-body>
          <div class="row mt-3">
            <div class="col-3">
              <button class="btn btn-primary btn-block" @click="
                iarPage--;
              iarPagination--;
              ">
                Back
              </button>
            </div>
            <div class="col-5"></div>
            <div class="col-4">
              <button class="btn btn-success btn-block" @click="onCreateDelivery()">
                Post
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- Post IAR -->
    <b-modal id="modal-post" :title="modalTitle" size="xl" title-class="font-18" hide-footer no-close-on-backdrop>
      <div v-if="modalTitle == 'Create IAR'" class="mb-3">
        <div class="d-flex justify-content-between">
          <div class="mb-3">
            <h5 class="mb-0">{{ form.poNumber }}</h5>
            <div>
              {{ form.supplier }}
            </div>
          </div>
        </div>
        <div>
          <b-card-body class="border">
            <div class="mb-3">
              <div class="form-check form-checkbox-outline form-check-success">
                <input type="checkbox" id="autoGenerate" checked="checked" class="form-check-input"
                  v-model="generateIAR" /><label for="autoGenerate" class="form-check-label">
                  Auto Generate IAR Number
                </label>
              </div>
            </div>
            <b-collapse :visible="!generateIAR">
              <div v-if="!generateIAR" class="mb-3">
                <label for="iarNumber">IAR Number </label>
                <input id="iarNumber" type="text" v-model="form.iarNumber" placeholder="Enter IAR Number..."
                  class="form-control" :class="{
                    'is-invalid':
                      submitted && !generateIAR && form.iarNumber == ''
                  }" autocomplete="off"
                  onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 45" />
                <div v-if="submitted && !generateIAR && form.iarNumber == ''" class="invalid-feedback">
                  <span>This value is required.</span>
                </div>
              </div>
            </b-collapse>
            <div class="row">
              <div class="col-6">
                <div class="mb-3">
                  <label for="dateInspected">Inspection Date</label>
                  <date-picker v-model="form.dateInspected" lang="en" placeholder="Enter Date Inspected..." :class="{
                    'is-invalid': submitted && $v.form.dateInspected.$error
                  }"></date-picker>
                  <div v-if="submitted && $v.form.dateInspected.$error" class="invalid-feedback">
                    <span v-if="!$v.form.dateInspected.required">This value is required.</span>
                  </div>
                </div>
                <div class="mb-3">
                  <label for="supplySignatoryName">Supply Signatory </label>
                  <b-input-group>
                    <template #append>
                      <b-button v-if="form.supplySignatoryId == null" @click="getEmployee('supply')"
                        variant="outline-info"><i class="mdi mdi-clipboard-text-search-outline"></i></b-button>
                      <b-button v-else @click="removeEmployee('supply')" variant="outline-danger"><i
                          class="mdi mdi-close-thick"></i></b-button>
                    </template>
                    <input autocomplete="off" type="text" disabled placeholder="Search Supply Signatory..."
                      class="form-control" v-model="form.supplySignatoryName" />
                  </b-input-group>
                </div>
                <div class="mb-3">
                  <label for="supplySignatoryPosition">Supply Signatory Position</label>
                  <input id="supplySignatoryPosition" type="text" v-model="form.supplySignatoryPosition"
                    placeholder="Enter Supply Signatory Position..." class="form-control" autocomplete="off" />
                </div>
              </div>
              <div class="col-6">
                <div class="mb-3">
                  <label for="drNumber">Invoice Number / D.R. Number</label>
                  <input id="drNumber" type="text" v-model="form.drNumber" placeholder="Enter Invoice/D.R. Number..."
                    class="form-control" :class="{
                      'is-invalid': submitted && $v.form.drNumber.$error
                    }" autocomplete="off" />
                  <div v-if="submitted && $v.form.drNumber.$error" class="invalid-feedback">
                    <span v-if="!$v.form.drNumber.required">This value is required.</span>
                  </div>
                </div>
                <div class="mb-3">
                  <label for="inspectionHead">Inspection Head</label>
                  <b-input-group>
                    <template #append>
                      <b-button v-if="form.inspectionHeadId == null" @click="getEmployee('inspection')"
                        variant="outline-info"><i class="mdi mdi-clipboard-text-search-outline"></i></b-button>
                      <b-button v-else @click="removeEmployee('inspection')" variant="outline-danger"><i
                          class="mdi mdi-close-thick"></i></b-button>
                    </template>
                    <input autocomplete="off" type="text" disabled placeholder="Search Inspection Head..."
                      class="form-control" v-model="form.inspectionHeadName" />
                  </b-input-group>
                </div>
              </div>
            </div>
            <div class="mb-4">
              <table width="100%">
                <thead>
                  <tr class="border-bottom">
                    <th style="width: 90px" class="py-2">Qty</th>
                    <th class="py-2">Item Name</th>
                    <th class="py-2" style="width: 150px">Status</th>
                    <th class="py-2" style="width: 150px">Unit Price</th>
                    <th class="py-2" style="width: 150px">Total Price</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="y in form.iarItems" :key="y.id" class="border-bottom">
                    <td class="py-2 align-top" v-if="y.id !== null">
                      {{ y.quantity }}
                    </td>
                    <td class="py-2 align-top" v-if="y.id !== null">
                      {{ y.itemName }}
                    </td>
                    <td class="py-2 align-top" v-if="y.id !== null">
                      <div :class="y.isDelivered ? 'text-success' : 'text-danger'">
                        {{ y.isDelivered ? "DELIVERED" : "WAIVED" }}
                      </div>
                    </td>
                    <td class="py-2 align-top text-warning" v-if="y.id !== null">
                      {{ formatCurrency(getExactAmt(y.unitCost)) }}
                    </td>
                    <td class="py-2 align-top text-warning" v-if="y.id !== null">
                      {{ formatCurrency(getExactAmt(y.total)) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-card-body>
          <div class="d-flex float-end mt-3 w-10">
            <button class="btn btn-success btn-block" @click="onCreate()">
              Post
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- Post Waived IAR -->
    <b-modal id="modal-post-waived" :title="modalTitle" size="md" title-class="font-18" hide-footer
      no-close-on-backdrop>
      <form @submit.prevent="onPostWaived" class="needs-validation" ref="fcForm">
        <div class="mb-3">
          <div class="form-check form-checkbox-outline form-check-success">
            <input type="checkbox" id="autoGenerate" checked="checked" class="form-check-input"
              v-model="generateIAR" /><label for="autoGenerate" class="form-check-label">
              Auto Generate IAR Number
            </label>
          </div>
        </div>
        <b-collapse :visible="!generateIAR">
          <div v-if="!generateIAR" class="mb-3">
            <label for="iarNumber">IAR Number </label>
            <input id="iarNumber" type="text" v-model="form.iarNumber" placeholder="Enter IAR Number..."
              class="form-control" :class="{
                'is-invalid': submitted && !generateIAR && form.iarNumber == ''
              }" autocomplete="off"
              onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 45" />
            <div v-if="submitted && !generateIAR && form.iarNumber == ''" class="invalid-feedback">
              <span>This value is required.</span>
            </div>
          </div>
        </b-collapse>
        <div class="mb-1">
          <label for="dateInspected">Inspection Date</label>
          <date-picker v-model="form.dateInspected" lang="en" placeholder="Enter Date Inspected..." :class="{
            'is-invalid': submitted && $v.form.dateInspected.$error
          }"></date-picker>
          <div v-if="submitted && $v.form.dateInspected.$error" class="invalid-feedback">
            <span v-if="!$v.form.dateInspected.required">This value is required.</span>
          </div>
        </div>
        <div class="d-flex flex-row-reverse mb-1">
          <button class="btn btn-primary mt-3" type="submit">
            Post Item
          </button>
        </div>
      </form>
    </b-modal>
    <!-- Update IAR -->
    <b-modal id="modal-update" :title="modalTitle" :size="tabIndex == 0 ? 'sm' : 'md'" title-class="font-18" hide-footer
      no-close-on-backdrop>
      <form @submit.prevent="onUpdate" class="needs-validation" ref="fcForm">
        <div class="row">
          <div class="col">
            <div class="mb-3">
              <label for="dateOfDelivery">Date of Delivery</label>
              <date-picker v-model="form.dateOfDelivery" lang="en" placeholder="Enter Date of Delivery..." :class="{
                'is-invalid': submitted && (form.dateOfDelivery == '' || form.dateOfDelivery == null)
              }"></date-picker>
              <div v-if="submitted && (form.dateOfDelivery == '' || form.dateOfDelivery == null)" class="invalid-feedback">
                <span>This value is required.</span>
              </div>
            </div>
            <div v-if="!form.isWaived" class="mb-3">
              <label for="acceptanceDate">Acceptance Date</label>
              <date-picker v-model="form.acceptanceDate" lang="en"
                placeholder="Enter Date of Delivery..."></date-picker>
            </div>
            <div v-if="!form.isWaived && tabIndex == 1" class="mb-3">
              <label for="dateInspected">Date Inspected</label>
              <date-picker v-model="form.dateInspected" lang="en" placeholder="Enter Date Inspected..." :class="{
                'is-invalid': submitted && (form.dateInspected == '' || form.dateInspected == null)
              }"></date-picker>
              <div v-if="submitted && (form.dateInspected == '' || form.dateInspected == null)" class="invalid-feedback">
                <span>This value is required.</span>
              </div>
            </div>
            <div v-if="!form.isWaived" class="mb-1">
              <label for="drNumber">Invoice Number / D.R. Number</label>
              <input id="drNumber" type="text" v-model="form.drNumber" placeholder="Enter Invoice/D.R. Number..."
                class="form-control" :class="{
                  'is-invalid': submitted && form.drNumber == ''
                }" autocomplete="off" />
              <div v-if="submitted && form.drNumber == ''" class="invalid-feedback">
                <span>This value is required.</span>
              </div>
            </div>
          </div>
          <div class="col" v-if="tabIndex == 1">
            <div class="mb-3">
              <label for="inspectionHead">Inspection Head</label>
              <b-input-group>
                <template #append>
                  <b-button v-if="form.inspectionHeadId == null" @click="getEmployee('inspection')"
                    variant="outline-info"><i class="mdi mdi-clipboard-text-search-outline"></i></b-button>
                  <b-button v-else @click="removeEmployee('inspection')" variant="outline-danger"><i
                      class="mdi mdi-close-thick"></i></b-button>
                </template>
                <input autocomplete="off" type="text" disabled placeholder="Search Inspection Head..."
                  class="form-control" v-model="form.inspectionHeadName" />
              </b-input-group>
            </div>
            <div class="mb-3">
              <label for="supplySignatoryName">Supply Signatory </label>
              <b-input-group>
                <template #append>
                  <b-button v-if="form.supplySignatoryId == null" @click="getEmployee('supply')"
                    variant="outline-info"><i class="mdi mdi-clipboard-text-search-outline"></i></b-button>
                  <b-button v-else @click="removeEmployee('supply')" variant="outline-danger"><i
                      class="mdi mdi-close-thick"></i></b-button>
                </template>
                <input autocomplete="off" type="text" disabled placeholder="Search Supply Signatory..."
                  class="form-control" v-model="form.supplySignatoryName" />
              </b-input-group>
            </div>
            <div class="mb-1">
              <label for="supplySignatoryPosition">Supply Signatory Position</label>
              <input id="supplySignatoryPosition" type="text" v-model="form.supplySignatoryPosition"
                placeholder="Enter Supply Signatory Position..." class="form-control" autocomplete="off" />
            </div>
          </div>
        </div>
        <div class="d-flex flex-row-reverse mb-1">
          <button class="btn btn-primary mt-3" type="submit">
            Update Item
          </button>
        </div>
      </form>
    </b-modal>
    <!-- Main -->
    <!-- <transition name="fade">
      <div
        v-if="tabIndex == 0"
        class="text-right position-absolute"
        style="right: 65px"
      >
        <button
          type="button"
          @click="createDelivery()"
          class="btn btn-success btn-sm d-flex align-items-center ms-1 mt-1"
        >
          <i class="bx bx-plus fs-6 me-1"></i>Create Delivery
        </button>
      </div>
    </transition> -->
    <b-tabs content-class="pt-3 pb-3 text-muted" v-model="tabIndex" nav-class="nav-tabs-custom">
      <!-- Pending -->
      <b-tab @click="
        getPending(cycle);
      perPage = 10;
      currentPage = 1;
      filter = '';
      ">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="mdi mdi-clock-time-four-outline"></i>
          </span>
          <span class="d-none d-sm-inline-block">Pending</span>
        </template>
        <div v-if="tabIndex == 0" class="card border-4 border-top border-start-0 border-end-0 border-primary">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-md-6">
                <div class="d-flex align-items-center h-100">
                  <h4 class="mb-0">Pending List</h4>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex float-end">
                  <div id="tickets-table_filter" class="me-1">
                    <date-picker ref="dateFilter" style="width: 250px !important;" v-model="dateFilter"
                      :first-day-of-week="1" lang="en" range placeholder="Enter Date Range..."
                      :popupStyle="dateRangeIndex == 5 ? { right: 0 } : null" @change="checkDateFilter">
                      <div v-if="dateFilter != ''" slot="input" class="form-control">
                        <div v-if="
                          formatDateShort(new Date(dateFilter[0])) !=
                          formatDateShort(new Date(dateFilter[1]))
                        ">
                          {{
                            formatDateShort(new Date(dateFilter[0]))
                          }}
                          -
                          {{
                            formatDateShort(new Date(dateFilter[1]))
                          }}
                        </div>
                        <div v-else>
                          {{ formatDate(new Date(dateFilter[0])) }}
                        </div>
                      </div>
                      <template v-slot:sidebar>
                        <div @click="selectDate('Today')" class="py-1 px-2 cursor-pointer" :class="{
                          'date-range-selected': dateRangeIndex == 0
                        }">
                          Today
                        </div>
                        <div @click="selectDate('Yesterday')" class="py-1 px-2 cursor-pointer" :class="{
                          'date-range-selected': dateRangeIndex == 1
                        }">
                          Yesterday
                        </div>
                        <div @click="selectDate('Last 7 Days')" class="py-1 px-2 cursor-pointer" :class="{
                          'date-range-selected': dateRangeIndex == 2
                        }">
                          Last 7 Days
                        </div>
                        <div @click="selectDate('This Month')" class="py-1 px-2 cursor-pointer" :class="{
                          'date-range-selected': dateRangeIndex == 3
                        }">
                          This Month
                        </div>
                        <div @click="selectDate('This Year')" class="py-1 px-2 cursor-pointer" :class="{
                          'date-range-selected': dateRangeIndex == 4
                        }">
                          This Year
                        </div>
                        <div @click="selectDate('Custom')" class="py-1 px-2 cursor-pointer" :class="{
                          'date-range-selected': dateRangeIndex == 5
                        }">
                          Custom
                        </div>
                      </template>
                      <template v-if="dateRangeIndex != 5" v-slot:content>
                        {{ null }}
                      </template>
                    </date-picker>
                  </div>
                  <div id="tickets-table_filter" class="dataTables_filter me-1">
                    <label class="d-inline-flex align-items-center">
                      <b-form-input autocomplete="off" v-model="filter" type="search" placeholder="Search IAR..."
                        class="form-control"></b-form-input>
                    </label>
                  </div>
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center mb-0">
                      <b-form-select class="form-select" v-model="perPage" size="sm" :options="pageOptions">
                      </b-form-select>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="border p-3 d-flex align-items-center justify-content-center" v-if="loading">
              <div class="preloader-component me-2">
                <div class="status">
                  <div class="spinner-chase w-25px h-25px">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
              <h5 class="mb-0">Loading...</h5>
            </div>
            <div class="text-center border p-3" v-else-if="paginated.length == 0">
              <div v-if="filter != ''">
                <i class="fas fa-exclamation-triangle me-2"></i>There are no
                Deliveries matching your request
              </div>
              <div v-else>
                <i class="fas fa-exclamation-triangle me-2"></i>No Deliveries
                available
              </div>
            </div>
            <div v-else class="border">
              <div class="text-muted" role="tablist" v-for="(x, index) in paginated" :key="x.id">
                <b-card no-body class="mb-0 border shadow-none" :style="`z-index: ${paginated.length - index + 1000}`">
                  <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" />
                  <b-card-header header-tag="header" role="tab">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <div>PO# {{ x.poNumber }}</div>
                        <div class="text-white font-size-14 mb-1">
                          {{ x.poDescription }}
                        </div>
                        <div class="d-flex align-items-center">
                          <div v-b-tooltip.bottomleft.hover="'Date of Delivery'">
                            {{ formatDate(new Date(x.dateOfDelivery)) }}
                          </div>
                          <div class="mx-2">|</div>
                          <small>
                            <a href="javascript: void(0);" class="text-success d-flex align-items-center"
                              @click="getIarItems(x)">
                              {{ x.visible ? "Hide" : "Show" }}
                              Details
                              <i class="bx bx-chevron-right rotate font-size-14" :class="{
                                'rotate-90': x.visible
                              }"></i>
                            </a>
                          </small>
                        </div>
                      </div>
                      <div v-if="!viewOnly" class="float-end d-flex align-items-center">
                        <i class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2" :id="`iar-pending-popover-${x.id}`"
                          tabindex="0"></i>
                        <b-popover :target="`iar-pending-popover-${x.id}`" triggers="click blur" placement="leftbottom"
                          variant="secondary" custom-class="p-0">
                          <b-list-group class="w-100 fit">
                            <b-list-group-item button action class="d-flex align-items-center text-danger"
                              @click="deleteIar(x)"><i class="mdi mdi-trash-can font-size-18 me-1"></i>Return
                              Items</b-list-group-item>
                          </b-list-group>
                        </b-popover>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse class="border-bottom border-5" :visible="x.visible"
                    :accordion="`iar-pending-accordion-${x.id}`" role="tabpanel">
                    <div v-if="x.visible">
                      <b-card-body
                        class="border border-3 border-bottom-0 border-start-0 border-end-0 custom-table-responsive">
                        <div class="d-flex">
                          <div class="me-3" style="max-width: 360px">
                            <button v-if="!viewOnly" type="button" @click="!x.isWaived ? postIar(x) : postWaived(x)"
                              class="btn btn-sm btn-block btn-success d-flex align-items-center justify-content-center mb-2">
                              <i class="bx bx-plus fs-6 me-1"></i>Create IAR
                            </button>
                            <div class="d-flex align-items-center mb-1">
                              <b class="font-size-16">Delivery Details:</b>
                              <a v-if="!viewOnly" href="javascript:void(0);"
                                class="hover-max-width d-flex align-items-center" @click="updateIar(x, 'pending')">
                                <i class="bx bx-edit font-size-16 mx-1"></i>
                                <span>Edit Details</span>
                              </a>
                            </div>
                            <div class="ms-3 mb-3">
                              <div v-if="!x.isWaived" class="font-size-12 mb-1">
                                Invoice/DR Number:
                                <b class="font-size-14">{{ x.drNumber }}</b>
                              </div>
                              <div class="font-size-12 mb-1">
                                Date of Delivery:
                                <b v-if="checkDate(x.dateOfDelivery)" class="font-size-14">{{
                                  formatDate(new Date(x.dateOfDelivery))
                                }}</b>
                              </div>
                              <div class="font-size-12 mb-1">
                                Acceptance Date:
                                <b v-if="checkDate(x.acceptanceDate)" class="font-size-14">{{
                                  formatDate(new Date(x.acceptanceDate))
                                }}</b>
                              </div>
                              <div class="font-size-12 mb-1">
                                Requisitioning Office/Dept:
                                <b class="font-size-14">{{
                                  x.deliveryUnit
                                    ? x.deliveryUnit
                                    : "Not Indicated"
                                }}</b>
                              </div>
                              <div class="font-size-12 mb-3">
                                Processed By:
                                <b class="font-size-14">{{
                                  x.createdBy
                                    ? x.createdBy
                                    : "n/a"
                                }}</b>
                              </div>
                              <button v-if="!viewOnly && !x.isWaived" type="button" @click="sendEmail(x)"
                                class="btn btn-sm btn-info d-flex align-items-center me-1 mb-2">
                                <i class="mdi mdi-send-circle-outline fs-6 me-1"></i>Email COA
                              </button>
                              <div class="d-flex align-items-center">
                                <button type="button" @click="printNoticeOFDelivery(x.id)"
                                  class="btn btn-sm btn-purple d-flex align-items-center me-1">
                                  Print Notice of Delivery
                                </button>
                              </div>
                            </div>
                            <div class="d-flex align-items-center mb-1">
                              <b class="font-size-16 me-1">PO Details:</b>
                              <a href="javascript: void(0);" @click="getPO(x)">[Show More]</a>
                            </div>
                            <div class="ms-3 mb-3">
                              <div class="font-size-12">
                                {{ x.poNumber }}
                              </div>
                              <div class="font-size-14 mb-2">
                                {{ x.poDescription }}
                              </div>
                              <button v-if="!viewOnly" type="button" @click="getSuspension(x.poId)"
                                class="btn btn-sm btn-warning d-flex align-items-center me-1 mb-2">
                                <i class="mdi mdi-calendar-clock fs-6 me-1"></i>Show Contract Management
                              </button>
                              <div class="d-flex align-items-center">
                                <button type="button" @click="printDelay(x.poId)"
                                  class="btn btn-sm btn-purple d-flex align-items-center me-1"
                                  style="min-width: max-content">
                                  Print Report of Delay
                                </button>
                                <button type="button" @click="printDeliveryHistory(x.poId)"
                                  class="btn btn-sm btn-purple d-flex align-items-center me-1"
                                  style="min-width: max-content">
                                  Print Delivery & Inspection History
                                </button>
                              </div>
                            </div>
                            <div>
                              <b class="font-size-16 me-1">Attachments:</b>
                              <a href="javascript:void(0);" @click="getAttachments(x)"
                                :id="`pending-viewFiles-${x.id}`">[Show attachments]</a>
                              <b-popover :target="`pending-viewFiles-${x.id}`" triggers="click" placement="right"
                                :show.sync="x.viewFile" custom-class="popover-supplier">
                                <template v-slot:title>
                                  <div class="d-flex align-items-center justify-content-between">
                                    <small>Attachments</small>
                                    <span class="bx bx-x font-size-14 cursor-pointer"
                                      @click="x.viewFile = false"></span>
                                  </div>
                                </template>
                                <table class="table table-bordered" v-if="
                                  !x.attachmentLoading &&
                                  x.iarFiles.length > 0
                                ">
                                  <thead>
                                    <tr>
                                      <th>File Description</th>
                                      <th style="width: 30px"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="y in x.iarFiles" :key="y.id">
                                      <td @click="openDocument(y)" class="hoverable-link cursor-pointer">
                                        <div>
                                          {{ y.description }}
                                        </div>
                                        <small>
                                          <div>
                                            Uploaded By {{ y.uploadedBy }}
                                          </div>
                                          <div>
                                            {{
                                              formatDateWithTime(
                                                new Date(y.dateTimeUploaded)
                                              )
                                            }}
                                          </div>
                                        </small>
                                      </td>
                                      <td>
                                        <i v-if="
                                          isAdmin ||
                                          y.applicationUserId ==
                                          token.ApplicationUserId
                                        " @click="removeFile(y.id, x.id)"
                                          class="cursor-pointer bx bx-trash text-danger"></i>
                                        <i v-else class="bx bx-trash text-muted"></i>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div class="text-center" v-if="
                                  !x.attachmentLoading &&
                                  x.iarFiles.length == 0
                                ">
                                  No data found
                                </div>
                                <div v-if="x.attachmentLoading" class="text-center">
                                  <b-spinner variant="primary" label="Loading..."></b-spinner>
                                </div>
                              </b-popover>
                            </div>
                            <div v-if="!viewOnly" class="mt-2">
                              <button :id="`pending-document${x.id}`" type="button"
                                class="btn btn-sm btn-outline-success" @click="x.addDocu = true">
                                <i class="bx bx-plus"></i>Add Attachments
                              </button>
                              <upload-popover :option="uploadOptions" :sourceId="x.id" @uploaded="uploadedFiles"
                                :showPV="x.addDocu" @closePopover="x.addDocu = false" :dzId="`dropzone-pending${x.id}`"
                                :pvId="`pending-document${x.id}`"></upload-popover>
                            </div>
                          </div>
                          <div class="border-start border-3 ps-2" style="width: 100%">
                            <div class="ms-2">
                              <div class="mb-2">
                                <div class="d-flex justify-content-between">
                                  <b class="font-size-16">Items:</b>
                                </div>
                              </div>
                              <div class="h-50vh d-flex align-items-center justify-content-center"
                                v-if="x.iarItems.length == 0">
                                <h5 class="text-muted">
                                  <i class="fas fa-exclamation-triangle me-2"></i>No Data Found
                                </h5>
                              </div>
                              <div v-else>
                                <table width="100%">
                                  <thead>
                                    <tr class="border-bottom">
                                      <th class="py-2 text-center" style="width: 60px">
                                        Qty
                                      </th>
                                      <th class="py-2" style="min-width: 250px">
                                        Item Name
                                      </th>
                                      <th class="py-2" style="width: 200px">
                                        Warehouse Location
                                      </th>
                                      <th class="py-2 text-center" style="width: 150px">
                                        Unit Price
                                      </th>
                                      <th class="py-2 text-center" style="width: 150px">
                                        Total Price
                                      </th>
                                      <th class="py-2 text-center" style="width: 100px">
                                        Status
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="y in x.iarItems" :key="y.id" class="border-bottom">
                                      <td class="py-2 align-top text-center text-info">
                                        <b>{{ y.quantity }}</b>
                                      </td>
                                      <td class="py-2 align-top pe-3">
                                        <div>{{ y.itemName }}</div>
                                        <small>{{ y.description }}</small>
                                      </td>
                                      <td class="py-2 align-top">
                                        {{
                                          y.locationArea ? y.locationArea : ""
                                        }}
                                      </td>
                                      <td class="py-2 align-top text-center" :class="y.isDelivered
                                        ? 'text-warning'
                                        : 'text-danger'
                                        ">
                                        {{ formatCurrency(y.unitCost) }}
                                      </td>
                                      <td class="py-2 align-top text-center" :class="y.isDelivered
                                        ? 'text-warning'
                                        : 'text-danger'
                                        ">
                                        {{
                                          formatCurrency(
                                            y.unitCost * y.quantity
                                          )
                                        }}
                                      </td>
                                      <td class="py-2 align-top text-center">
                                        <div class="badge p-2" :class="y.isDelivered
                                          ? 'bg-success'
                                          : 'bg-danger'
                                          ">
                                          <b class="font-size-12">{{
                                            y.isDelivered
                                              ? "DELIVERED"
                                              : "WAIVED"
                                          }}</b>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                  <tbody>
                                    <tr>
                                      <td class="py-2"></td>
                                      <td class="py-2"></td>
                                      <td class="py-2"></td>
                                      <td class="py-2 text-center font-size-15 text-warning">
                                        {{
                                          formatCurrency(getTotal(x.iarItems))
                                        }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-card-body>
                    </div>
                  </b-collapse>
                </b-card>
              </div>
            </div>
            <div class="row pt-3 pb-3">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="paginate pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <!-- IAR -->
      <b-tab @click="
        getPosted(cycle);
      perPage = 10;
      currentPage = 1;
      filter = '';
      ">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="mdi mdi-check-circle-outline"></i>
          </span>
          <span class="d-none d-sm-inline-block">IAR</span>
        </template>
        <div v-if="tabIndex == 1" class="card border-4 border-top border-start-0 border-end-0 border-primary">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-md-6">
                <div class="d-flex align-items-center h-100">
                  <h4 class="mb-0">IAR List</h4>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex float-end">
                  <div id="tickets-table_filter" class="me-1">
                    <date-picker ref="dateFilter" style="width: 250px !important;" v-model="dateFilter"
                      :first-day-of-week="1" lang="en" range placeholder="Enter Date Range..."
                      :popupStyle="dateRangeIndex == 5 ? { right: 0 } : null" @change="checkDateFilter">
                      <div v-if="dateFilter != ''" slot="input" class="form-control">
                        <div v-if="
                          formatDateShort(new Date(dateFilter[0])) !=
                          formatDateShort(new Date(dateFilter[1]))
                        ">
                          {{
                            formatDateShort(new Date(dateFilter[0]))
                          }}
                          -
                          {{
                            formatDateShort(new Date(dateFilter[1]))
                          }}
                        </div>
                        <div v-else>
                          {{ formatDate(new Date(dateFilter[0])) }}
                        </div>
                      </div>
                      <template v-slot:sidebar>
                        <div @click="selectDate('Today')" class="py-1 px-2 cursor-pointer" :class="{
                          'date-range-selected': dateRangeIndex == 0
                        }">
                          Today
                        </div>
                        <div @click="selectDate('Yesterday')" class="py-1 px-2 cursor-pointer" :class="{
                          'date-range-selected': dateRangeIndex == 1
                        }">
                          Yesterday
                        </div>
                        <div @click="selectDate('Last 7 Days')" class="py-1 px-2 cursor-pointer" :class="{
                          'date-range-selected': dateRangeIndex == 2
                        }">
                          Last 7 Days
                        </div>
                        <div @click="selectDate('This Month')" class="py-1 px-2 cursor-pointer" :class="{
                          'date-range-selected': dateRangeIndex == 3
                        }">
                          This Month
                        </div>
                        <div @click="selectDate('This Year')" class="py-1 px-2 cursor-pointer" :class="{
                          'date-range-selected': dateRangeIndex == 4
                        }">
                          This Year
                        </div>
                        <div @click="selectDate('Custom')" class="py-1 px-2 cursor-pointer" :class="{
                          'date-range-selected': dateRangeIndex == 5
                        }">
                          Custom
                        </div>
                      </template>
                      <template v-if="dateRangeIndex != 5" v-slot:content>
                        {{ null }}
                      </template>
                    </date-picker>
                  </div>
                  <div id="tickets-table_filter" class="dataTables_filter me-1">
                    <label class="d-inline-flex align-items-center">
                      <b-form-input autocomplete="off" v-model="filter" type="search" placeholder="Search IAR..."
                        class="form-control"></b-form-input>
                    </label>
                  </div>
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center mb-0">
                      <b-form-select class="form-select" v-model="perPage" size="sm" :options="pageOptions">
                      </b-form-select>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="border p-3 d-flex align-items-center justify-content-center" v-if="loading">
              <div class="preloader-component me-2">
                <div class="status">
                  <div class="spinner-chase w-25px h-25px">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
              <h5 class="mb-0">Loading...</h5>
            </div>
            <div class="text-center border p-3" v-else-if="paginated.length == 0">
              <div v-if="filter != ''">
                <i class="fas fa-exclamation-triangle me-2"></i>There are no
                IARs matching your request
              </div>
              <div v-else>
                <i class="fas fa-exclamation-triangle me-2"></i>No IARs
                available
              </div>
            </div>
            <div v-else class="border">
              <div class="text-muted" role="tablist" v-for="(x, index) in paginated" :key="x.id">
                <b-card no-body class="mb-0 border shadow-none" :style="`z-index: ${paginated.length - index + 1000}`">
                  <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" />
                  <b-card-header header-tag="header" role="tab">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <div class="d-flex align-items-center">
                          <div class="d-flex align-items-center" v-if="!x.editIAR">
                            <h5 class="mb-0">IAR# {{ x.iarNumber }}</h5>
                            <a v-if="!viewOnly" href="javascript:void(0);"
                              class="hover-max-width d-flex align-items-center" @click="updateIarNumber(x)">
                              <i class="bx bx-edit font-size-16 mx-1"></i>
                              <span>Edit IAR Number</span>
                            </a>
                          </div>
                          <div class="d-flex align-items-center" v-else-if="x.editIAR">
                            <input id="drNumber" type="text" v-model="x.iarNumberEdit"
                              placeholder="Enter D.R. Number..." class="form-control form-control-sm" :class="{
                                'is-invalid': submitted && x.iarNumberEdit == ''
                              }" autocomplete="off"
                              onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 45" />
                            <button type="button" class="ms-1 btn btn-sm btn-success no-wrap"
                              @click="onUpdateIarNumber(x)">
                              <span><i class="bx bx-save me-1"></i>Save</span>
                            </button>
                            <button type="button" class="ms-1 btn btn-sm no-wrap btn-link" @click="
                              x.editIAR = false;
                            x.iarNumberEdit = '';
                            ">
                              <span>Cancel</span>
                            </button>
                          </div>
                        </div>
                        <div class="text-white font-size-14 mb-1">
                          {{ x.poDescription }}
                        </div>
                        <div>PO# {{ x.poNumber }}</div>
                        <small>
                          <a href="javascript: void(0);" class="text-success d-flex align-items-center"
                            @click="getIarItems(x)">
                            {{ x.visible ? "Hide" : "Show" }}
                            Details
                            <i class="bx bx-chevron-right rotate font-size-14" :class="{
                              'rotate-90': x.visible
                            }"></i>
                          </a>
                        </small>
                      </div>
                      <div v-if="!viewOnly" class="float-end d-flex align-items-center">
                        <i class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2" :id="`iar-posted-popover-${x.id}`"
                          tabindex="0"></i>
                        <b-popover :target="`iar-posted-popover-${x.id}`" triggers="click blur" placement="leftbottom"
                          variant="secondary" custom-class="p-0">
                          <b-list-group class="w-100 fit">
                            <b-list-group-item button action class="d-flex align-items-center text-warning"
                              @click="unpostIar(x)"><i class="mdi mdi-undo-variant font-size-18 me-1"></i>Undo
                              IAR</b-list-group-item>
                          </b-list-group>
                        </b-popover>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse class="border-bottom border-5" :visible="x.visible"
                    :accordion="`iar-posted-accordion-${x.id}`" role="tabpanel">
                    <div v-if="x.visible">
                      <b-card-body
                        class="border border-3 border-bottom-0 border-start-0 border-end-0 custom-table-responsive">
                        <div class="d-flex">
                          <div class="me-3" style="max-width: 360px">
                            <div class="d-flex align-items-center mb-1">
                              <b class="font-size-16">IAR Details:</b>
                              <a v-if="!viewOnly" href="javascript:void(0);"
                                class="hover-max-width d-flex align-items-center" @click="updateIar(x, 'iar')">
                                <i class="bx bx-edit font-size-16 mx-1"></i>
                                <span>Edit Details</span>
                              </a>
                            </div>
                            <div class="ms-3 mb-3">
                              <div class="font-size-12 mb-1">
                                Date Inspected:
                                <b v-if="checkDate(x.dateInspected)" class="font-size-14">{{
                                  formatDate(new Date(x.dateInspected))
                                }}</b>
                              </div>
                              <div class="font-size-12 mb-1">
                                Invoice/DR Number:
                                <b class="font-size-14">{{ x.drNumber }}</b>
                              </div>
                              <div class="font-size-12 mb-1">
                                Date of Delivery:
                                <b v-if="checkDate(x.dateOfDelivery)" class="font-size-14">{{
                                  formatDate(new Date(x.dateOfDelivery))
                                }}</b>
                              </div>
                              <div class="font-size-12 mb-1">
                                Acceptance Date:
                                <b v-if="checkDate(x.acceptanceDate)" class="font-size-14">{{
                                  formatDate(new Date(x.acceptanceDate))
                                }}</b>
                              </div>
                              <div class="font-size-12 mb-1">
                                Requisitioning Office/Dept:
                                <b class="font-size-14">{{
                                  x.deliveryUnit
                                    ? x.deliveryUnit
                                    : "Not Indicated"
                                }}</b>
                              </div>
                              <div class="font-size-12 mb-1">
                                Inspection Head:
                                <b class="font-size-14">{{
                                  x.inspectionHead
                                    ? x.inspectionHead
                                    : "Not Indicated"
                                }}</b>
                              </div>
                              <div class="font-size-12 mb-3">
                                Supply Signatory:
                                <b class="font-size-14">{{
                                  x.supplySignatory
                                    ? x.supplySignatory
                                    : "Not Indicated"
                                }}</b>
                              </div>
                              <button v-if="!viewOnly" type="button" @click="sendEmail(x)"
                                class="btn btn-sm btn-info d-flex align-items-center me-1 mb-2">
                                <i class="mdi mdi-send-circle-outline fs-6 me-1"></i>Email COA
                              </button>
                              <div class="d-flex align-items-center">
                                <button type="button" @click="printIar(x.id)"
                                  class="btn btn-sm btn-purple d-flex align-items-center me-1">
                                  Print IAR
                                </button>
                                <button type="button" @click="printNoticeOFDelivery(x.id)"
                                  class="btn btn-sm btn-purple d-flex align-items-center me-1">
                                  Print Notice of Delivery
                                </button>
                              </div>
                            </div>
                            <div class="d-flex align-items-center mb-1">
                              <b class="font-size-16 me-1">PO Details:</b>
                              <a href="javascript: void(0);" @click="getPO(x)">[Show More]</a>
                            </div>
                            <div class="ms-3 mb-3">
                              <div class="font-size-12">
                                {{ x.poNumber }}
                              </div>
                              <div class="font-size-14 mb-2">
                                {{ x.poDescription }}
                              </div>
                              <button v-if="!viewOnly" type="button" @click="getSuspension(x.poId)"
                                class="btn btn-sm btn-warning d-flex align-items-center me-1 mb-2">
                                <i class="mdi mdi-calendar-clock fs-6 me-1"></i>Show Contract Management
                              </button>
                              <div class="d-flex align-items-center">
                                <button type="button" @click="printDelay(x.poId)"
                                  class="btn btn-sm btn-purple d-flex align-items-center me-1"
                                  style="min-width: max-content">
                                  Print Report of Delay
                                </button>
                                <button type="button" @click="printDeliveryHistory(x.poId)"
                                  class="btn btn-sm btn-purple d-flex align-items-center me-1"
                                  style="min-width: max-content">
                                  Print Delivery & Inspection History
                                </button>
                              </div>
                            </div>
                            <div>
                              <b class="font-size-16 me-1">Attachments:</b>
                              <a href="javascript:void(0);" class="ms-1" @click="getAttachments(x)"
                                :id="`posted-viewFiles-${x.id}`">[Show attachments]</a>
                              <b-popover :target="`posted-viewFiles-${x.id}`" triggers="click" placement="right"
                                :show.sync="x.viewFile" custom-class="popover-supplier">
                                <template v-slot:title>
                                  <div class="d-flex align-items-center justify-content-between">
                                    <small>Attachments</small>
                                    <span class="bx bx-x font-size-14 cursor-pointer"
                                      @click="x.viewFile = false"></span>
                                  </div>
                                </template>
                                <table class="table table-bordered" v-if="
                                  !x.attachmentLoading &&
                                  x.iarFiles.length > 0
                                ">
                                  <thead>
                                    <tr>
                                      <th>File Description</th>
                                      <th style="width: 30px"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="y in x.iarFiles" :key="y.id">
                                      <td @click="openDocument(y)" class="hoverable-link cursor-pointer">
                                        <div>
                                          {{ y.description }}
                                        </div>
                                        <small>
                                          <div>
                                            Uploaded By {{ y.uploadedBy }}
                                          </div>
                                          <div>
                                            {{
                                              formatDateWithTime(
                                                new Date(y.dateTimeUploaded)
                                              )
                                            }}
                                          </div>
                                        </small>
                                      </td>
                                      <td>
                                        <i v-if="
                                          isAdmin ||
                                          y.applicationUserId ==
                                          token.ApplicationUserId
                                        " @click="removeFile(y.id, x.id)"
                                          class="cursor-pointer bx bx-trash text-danger"></i>
                                        <i v-else class="bx bx-trash text-muted"></i>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div class="text-center" v-if="
                                  !x.attachmentLoading &&
                                  x.iarFiles.length == 0
                                ">
                                  No data found
                                </div>
                                <div v-if="x.attachmentLoading" class="text-center">
                                  <b-spinner variant="primary" label="Loading..."></b-spinner>
                                </div>
                              </b-popover>
                            </div>
                            <div v-if="!viewOnly" class="mt-2">
                              <button :id="`posted-document${x.id}`" type="button"
                                class="btn btn-sm btn-outline-success" @click="x.addDocu = true">
                                <i class="bx bx-plus"></i>Add Attachments
                              </button>
                              <upload-popover :option="uploadOptions" :sourceId="x.id" @uploaded="uploadedFiles"
                                :showPV="x.addDocu" @closePopover="x.addDocu = false" :dzId="`dropzone-posted${x.id}`"
                                :pvId="`posted-document${x.id}`"></upload-popover>
                            </div>
                          </div>
                          <div class="border-start border-3 ps-2" style="width: 100%">
                            <div class="ms-2">
                              <div class="mb-2">
                                <div class="d-flex justify-content-between">
                                  <b class="font-size-16">Items:</b>
                                </div>
                              </div>
                              <div class="h-50vh d-flex align-items-center justify-content-center"
                                v-if="x.iarItems.length == 0">
                                <h5 class="text-muted">
                                  <i class="fas fa-exclamation-triangle me-2"></i>No Data Found
                                </h5>
                              </div>
                              <div v-else>
                                <table width="100%">
                                  <thead>
                                    <tr class="border-bottom">
                                      <th class="py-2 text-center" style="width: 60px">
                                        Qty
                                      </th>
                                      <th class="py-2" style="min-width: 250px">
                                        Item Name
                                      </th>
                                      <th class="py-2" style="width: 200px">
                                        Warehouse Location
                                      </th>
                                      <th class="py-2 text-center" style="width: 150px">
                                        Unit Price
                                      </th>
                                      <th class="py-2 text-center" style="width: 150px">
                                        Total Price
                                      </th>
                                      <th class="py-2 text-center" style="width: 100px">
                                        Status
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="y in x.iarItems" :key="y.id" class="border-bottom">
                                      <td class="py-2 align-top text-center text-info">
                                        <b>{{ y.quantity }}</b>
                                      </td>
                                      <td class="py-2 align-top pe-3">
                                        <div>{{ y.itemName }}</div>
                                        <small>{{ y.description }}</small>
                                      </td>
                                      <td class="py-2 align-top">
                                        {{
                                          y.locationArea ? y.locationArea : ""
                                        }}
                                      </td>
                                      <td class="py-2 align-top text-center" :class="y.isDelivered
                                        ? 'text-warning'
                                        : 'text-danger'
                                        ">
                                        {{ formatCurrency(y.unitCost) }}
                                      </td>
                                      <td class="py-2 align-top text-center" :class="y.isDelivered
                                        ? 'text-warning'
                                        : 'text-danger'
                                        ">
                                        {{
                                          formatCurrency(
                                            y.unitCost * y.quantity
                                          )
                                        }}
                                      </td>
                                      <td class="py-2 align-top text-center">
                                        <div class="badge p-2" :class="y.isDelivered
                                          ? 'bg-success'
                                          : 'bg-danger'
                                          ">
                                          <b class="font-size-12">{{
                                            y.isDelivered
                                              ? "DELIVERED"
                                              : "WAIVED"
                                          }}</b>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                  <tbody>
                                    <tr>
                                      <td class="py-2"></td>
                                      <td class="py-2"></td>
                                      <td class="py-2"></td>
                                      <td class="py-2"></td>
                                      <td class="py-2 text-center font-size-15 text-warning">
                                        {{
                                          formatCurrency(getTotal(x.iarItems))
                                        }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-card-body>
                    </div>
                  </b-collapse>
                </b-card>
              </div>
            </div>
            <div class="row pt-3 pb-3">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="paginate pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <!-- Completed -->
      <b-tab @click="
        getCompleted(cycle);
      perPage = 10;
      currentPage = 1;
      filter = '';
      ">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="mdi mdi-check-circle-outline"></i>
          </span>
          <span class="d-none d-sm-inline-block">Completed</span>
        </template>
        <div v-if="tabIndex == 2" class="card border-4 border-top border-start-0 border-end-0 border-primary">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-md-6">
                <div class="d-flex align-items-center h-100">
                  <h4 class="mb-0">Completed IAR List</h4>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex float-end">
                  <div id="tickets-table_filter" class="me-1">
                    <date-picker ref="dateFilter" style="width: 250px !important;" v-model="dateFilter"
                      :first-day-of-week="1" lang="en" range placeholder="Enter Date Range..."
                      :popupStyle="dateRangeIndex == 5 ? { right: 0 } : null" @change="checkDateFilter">
                      <div v-if="dateFilter != ''" slot="input" class="form-control">
                        <div v-if="
                          formatDateShort(new Date(dateFilter[0])) !=
                          formatDateShort(new Date(dateFilter[1]))
                        ">
                          {{
                            formatDateShort(new Date(dateFilter[0]))
                          }}
                          -
                          {{
                            formatDateShort(new Date(dateFilter[1]))
                          }}
                        </div>
                        <div v-else>
                          {{ formatDate(new Date(dateFilter[0])) }}
                        </div>
                      </div>
                      <template v-slot:sidebar>
                        <div @click="selectDate('Today')" class="py-1 px-2 cursor-pointer" :class="{
                          'date-range-selected': dateRangeIndex == 0
                        }">
                          Today
                        </div>
                        <div @click="selectDate('Yesterday')" class="py-1 px-2 cursor-pointer" :class="{
                          'date-range-selected': dateRangeIndex == 1
                        }">
                          Yesterday
                        </div>
                        <div @click="selectDate('Last 7 Days')" class="py-1 px-2 cursor-pointer" :class="{
                          'date-range-selected': dateRangeIndex == 2
                        }">
                          Last 7 Days
                        </div>
                        <div @click="selectDate('This Month')" class="py-1 px-2 cursor-pointer" :class="{
                          'date-range-selected': dateRangeIndex == 3
                        }">
                          This Month
                        </div>
                        <div @click="selectDate('This Year')" class="py-1 px-2 cursor-pointer" :class="{
                          'date-range-selected': dateRangeIndex == 4
                        }">
                          This Year
                        </div>
                        <div @click="selectDate('Custom')" class="py-1 px-2 cursor-pointer" :class="{
                          'date-range-selected': dateRangeIndex == 5
                        }">
                          Custom
                        </div>
                      </template>
                      <template v-if="dateRangeIndex != 5" v-slot:content>
                        {{ null }}
                      </template>
                    </date-picker>
                  </div>
                  <div id="tickets-table_filter" class="dataTables_filter me-1">
                    <label class="d-inline-flex align-items-center">
                      <b-form-input autocomplete="off" v-model="filter" type="search" placeholder="Search IAR..."
                        class="form-control"></b-form-input>
                    </label>
                  </div>
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center mb-0">
                      <b-form-select class="form-select" v-model="perPage" size="sm" :options="pageOptions">
                      </b-form-select>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="border p-3 d-flex align-items-center justify-content-center" v-if="loading">
              <div class="preloader-component me-2">
                <div class="status">
                  <div class="spinner-chase w-25px h-25px">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
              <h5 class="mb-0">Loading...</h5>
            </div>
            <div class="text-center border p-3" v-else-if="paginated.length == 0">
              <div v-if="filter != ''">
                <i class="fas fa-exclamation-triangle me-2"></i>There are no
                Completed IARs matching your request
              </div>
              <div v-else>
                <i class="fas fa-exclamation-triangle me-2"></i>No Completed
                IARs available
              </div>
            </div>
            <div v-else class="border">
              <div class="text-muted" role="tablist" v-for="(x, index) in paginated" :key="x.id">
                <b-card no-body class="mb-0 border shadow-none" :style="`z-index: ${paginated.length - index + 1000}`">
                  <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" />
                  <b-card-header header-tag="header" role="tab">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <div class="d-flex align-items-center">
                          <div class="d-flex align-items-center" v-if="!x.editIAR">
                            <h5 class="mb-0">IAR# {{ x.iarNumber }}</h5>
                            <a v-if="!viewOnly" href="javascript:void(0);"
                              class="hover-max-width d-flex align-items-center" @click="updateIarNumber(x)">
                              <i class="bx bx-edit font-size-16 mx-1"></i>
                              <span>Edit IAR Number</span>
                            </a>
                          </div>
                          <div class="d-flex align-items-center" v-else-if="x.editIAR">
                            {{}}
                            <input id="drNumber" type="text" v-model="x.iarNumberEdit"
                              placeholder="Enter D.R. Number..." class="form-control form-control-sm" :class="{
                                'is-invalid': submitted && x.iarNumberEdit == ''
                              }" autocomplete="off"
                              onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 45" />
                            <button type="button" class="ms-1 btn btn-sm btn-success no-wrap"
                              @click="onUpdateIarNumber(x)">
                              <span><i class="bx bx-save me-1"></i>Save</span>
                            </button>
                            <button type="button" class="ms-1 btn btn-sm no-wrap btn-link" @click="
                              x.editIAR = false;
                            x.iarNumberEdit = '';
                            ">
                              <span>Cancel</span>
                            </button>
                          </div>
                        </div>
                        <div class="text-white font-size-14 mb-1">
                          {{ x.poDescription }}
                        </div>
                        <div>PO# {{ x.poNumber }}</div>
                        <small>
                          <a href="javascript: void(0);" class="text-success d-flex align-items-center"
                            @click="getIarItems(x)">
                            {{ x.visible ? "Hide" : "Show" }}
                            Details
                            <i class="bx bx-chevron-right rotate font-size-14" :class="{
                              'rotate-90': x.visible
                            }"></i>
                          </a>
                        </small>
                      </div>
                    </div>
                  </b-card-header>
                  <b-collapse class="border-bottom border-5" :visible="x.visible"
                    :accordion="`iar-completed-accordion-${x.id}`" role="tabpanel">
                    <div v-if="x.visible">
                      <b-card-body
                        class="border border-3 border-bottom-0 border-start-0 border-end-0 custom-table-responsive">
                        <div class="d-flex">
                          <div class="me-3" style="max-width: 360px">
                            <div class="d-flex align-items-center mb-1">
                              <b class="font-size-16">IAR Details:</b>
                              <a v-if="!viewOnly" href="javascript:void(0);"
                                class="hover-max-width d-flex align-items-center" @click="updateIar(x, 'completed')">
                                <i class="bx bx-edit font-size-16 mx-1"></i>
                                <span>Edit Details</span>
                              </a>
                            </div>
                            <div class="ms-3 mb-3">
                              <div class="font-size-12 mb-1">
                                Date Inspected:
                                <b v-if="checkDate(x.dateInspected)" class="font-size-14">{{
                                  formatDate(new Date(x.dateInspected))
                                }}</b>
                              </div>
                              <div class="d-flex align-items-center mb-1">
                                <div class="font-size-12 me-1" style="min-width: max-content">
                                  Invoice/DR Number:
                                </div>
                                <div class="d-flex align-items-center" v-if="!x.editDR">
                                  <b class="font-size-14 text-truncate" style="max-width:180px">{{ x.drNumber }}</b>
                                  <!-- <a v-if="!viewOnly" href="javascript:void(0);"
                                    class="hover-max-width d-flex align-items-center" @click="updateDRNumber(x)">
                                    <i class="bx bx-edit font-size-16 mx-1"></i>
                                    <span>Edit</span>
                                  </a> -->
                                </div>
                                <!-- <div class="d-flex align-items-center" v-else-if="x.editDR">
                                  <input id="drNumber" type="text" v-model="x.drNumberEdit"
                                    placeholder="Enter D.R. Number..." class="form-control form-control-sm" :class="{
                                      'is-invalid':
                                        submitted && x.drNumberEdit == ''
                                    }" autocomplete="off" />
                                  <button type="button" class="ms-1 btn btn-sm btn-success no-wrap"
                                    @click="onUpdateDRNumber(x)">
                                    <span><i class="bx bx-save me-1"></i>Save</span>
                                  </button>
                                  <button type="button" class="ms-1 btn btn-sm no-wrap btn-link" @click="
                                    x.editDR = false;
                                  x.drNumberEdit = '';
                                  ">
                                    <span>Cancel</span>
                                  </button>
                                </div> -->
                              </div>
                              <div class="font-size-12 mb-1">
                                Date of Delivery:
                                <b v-if="checkDate(x.dateOfDelivery)" class="font-size-14">{{
                                  formatDate(new Date(x.dateOfDelivery))
                                }}</b>
                              </div>
                              <div class="font-size-12 mb-1">
                                Acceptance Date:
                                <b v-if="checkDate(x.acceptanceDate)" class="font-size-14">{{
                                  formatDate(new Date(x.acceptanceDate))
                                }}</b>
                              </div>
                              <div class="font-size-12 mb-1">
                                Requisitioning Office/Dept:
                                <b class="font-size-14">{{
                                  x.deliveryUnit
                                    ? x.deliveryUnit
                                    : "Not Indicated"
                                }}</b>
                              </div>
                              <div class="font-size-12 mb-1">
                                Inspection Head:
                                <b class="font-size-14">{{
                                  x.inspectionHead
                                    ? x.inspectionHead
                                    : "Default"
                                }}</b>
                              </div>
                              <div class="font-size-12 mb-3">
                                Supply Signatory:
                                <b class="font-size-14">{{
                                  x.supplySignatory
                                    ? x.supplySignatory
                                    : "Default"
                                }}</b>
                              </div>
                              <button v-if="!viewOnly" type="button" @click="sendEmail(x)"
                                class="btn btn-sm btn-info d-flex align-items-center me-1 mb-2">
                                <i class="mdi mdi-send-circle-outline fs-6 me-1"></i>Email COA
                              </button>
                              <div class="d-flex align-items-center">
                                <button type="button" @click="printIar(x.id)"
                                  class="btn btn-sm btn-purple d-flex align-items-center me-1">
                                  Print IAR
                                </button>
                                <button type="button" @click="printNoticeOFDelivery(x.id)"
                                  class="btn btn-sm btn-purple d-flex align-items-center me-1">
                                  Print Notice of Delivery
                                </button>
                              </div>
                            </div>
                            <div class="d-flex align-items-center mb-1">
                              <b class="font-size-16 me-1">PO Details:</b>
                              <a href="javascript: void(0);" @click="getPO(x)">[Show More]</a>
                            </div>
                            <div class="ms-3 mb-3">
                              <div class="font-size-12">
                                {{ x.poNumber }}
                              </div>
                              <div class="font-size-14 mb-2">
                                {{ x.poDescription }}
                              </div>
                              <button v-if="!viewOnly" type="button" @click="getSuspension(x.poId)"
                                class="btn btn-sm btn-warning d-flex align-items-center me-1 mb-2">
                                <i class="mdi mdi-calendar-clock fs-6 me-1"></i>Show Contract Management
                              </button>
                              <div class="d-flex align-items-center">
                                <button type="button" @click="printDelay(x.poId)"
                                  class="btn btn-sm btn-purple d-flex align-items-center me-1"
                                  style="min-width: max-content">
                                  Print Report of Delay
                                </button>
                                <button type="button" @click="printDeliveryHistory(x.poId)"
                                  class="btn btn-sm btn-purple d-flex align-items-center me-1"
                                  style="min-width: max-content">
                                  Print Delivery & Inspection History
                                </button>
                              </div>
                            </div>
                            <div>
                              <b class="font-size-16 me-1">Attachments:</b>
                              <a href="javascript:void(0);" class="ms-1" @click="getAttachments(x)"
                                :id="`completed-viewFiles-${x.id}`">[Show attachments]</a>
                              <b-popover :target="`completed-viewFiles-${x.id}`" triggers="click" placement="right"
                                :show.sync="x.viewFile" custom-class="popover-supplier">
                                <template v-slot:title>
                                  <div class="d-flex align-items-center justify-content-between">
                                    <small>Attachments</small>
                                    <span class="bx bx-x font-size-14 cursor-pointer"
                                      @click="x.viewFile = false"></span>
                                  </div>
                                </template>
                                <table class="table table-bordered" v-if="
                                  !x.attachmentLoading &&
                                  x.iarFiles.length > 0
                                ">
                                  <thead>
                                    <tr>
                                      <th>File Description</th>
                                      <th style="width: 30px"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="y in x.iarFiles" :key="y.id">
                                      <td @click="openDocument(y)" class="hoverable-link cursor-pointer">
                                        <div>
                                          {{ y.description }}
                                        </div>
                                        <small>
                                          <div>
                                            Uploaded By {{ y.uploadedBy }}
                                          </div>
                                          <div>
                                            {{
                                              formatDateWithTime(
                                                new Date(y.dateTimeUploaded)
                                              )
                                            }}
                                          </div>
                                        </small>
                                      </td>
                                      <td>
                                        <i v-if="
                                          isAdmin ||
                                          y.applicationUserId ==
                                          token.ApplicationUserId
                                        " @click="removeFile(y.id, x.id)"
                                          class="cursor-pointer bx bx-trash text-danger"></i>
                                        <i v-else class="bx bx-trash text-muted"></i>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div class="text-center" v-if="
                                  !x.attachmentLoading &&
                                  x.iarFiles.length == 0
                                ">
                                  No data found
                                </div>
                                <div v-if="x.attachmentLoading" class="text-center">
                                  <b-spinner variant="primary" label="Loading..."></b-spinner>
                                </div>
                              </b-popover>
                            </div>
                            <div v-if="!viewOnly" class="mt-2">
                              <button :id="`completed-document${x.id}`" type="button"
                                class="btn btn-sm btn-outline-success" @click="x.addDocu = true">
                                <i class="bx bx-plus"></i>Add Attachments
                              </button>
                              <upload-popover :option="uploadOptions" :sourceId="x.id" @uploaded="uploadedFiles"
                                :showPV="x.addDocu" @closePopover="x.addDocu = false"
                                :dzId="`dropzone-completed${x.id}`"
                                :pvId="`completed-document${x.id}`"></upload-popover>
                            </div>
                          </div>
                          <div class="border-start border-3 ps-2" style="width: 100%">
                            <div class="ms-2">
                              <div class="mb-2">
                                <div class="d-flex justify-content-between">
                                  <b class="font-size-16">Items:</b>
                                </div>
                              </div>
                              <div class="h-50vh d-flex align-items-center justify-content-center"
                                v-if="x.iarItems.length == 0">
                                <h5 class="text-muted">
                                  <i class="fas fa-exclamation-triangle me-2"></i>No Data Found
                                </h5>
                              </div>
                              <div v-else>
                                <table width="100%">
                                  <thead>
                                    <tr class="border-bottom">
                                      <th class="py-2 text-center" style="width: 60px">
                                        Qty
                                      </th>
                                      <th class="py-2" style="min-width: 250px">
                                        Item Name
                                      </th>
                                      <th class="py-2" style="width: 200px">
                                        Warehouse Location
                                      </th>
                                      <th class="py-2 text-center" style="width: 150px">
                                        Unit Price
                                      </th>
                                      <th class="py-2 text-center" style="width: 150px">
                                        Total Price
                                      </th>
                                      <th class="py-2 text-center" style="width: 100px">
                                        Status
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="y in x.iarItems" :key="y.id" class="border-bottom">
                                      <td class="py-2 align-top text-center text-info">
                                        <b>{{ y.quantity }}</b>
                                      </td>
                                      <td class="py-2 align-top pe-3">
                                        <div>{{ y.itemName }}</div>
                                        <small>{{ y.description }}</small>
                                      </td>
                                      <td class="py-2 align-top">
                                        {{
                                          y.locationArea ? y.locationArea : ""
                                        }}
                                      </td>
                                      <td class="py-2 align-top text-center" :class="y.isDelivered
                                        ? 'text-warning'
                                        : 'text-danger'
                                        ">
                                        {{ formatCurrency(y.unitCost) }}
                                      </td>
                                      <td class="py-2 align-top text-center" :class="y.isDelivered
                                        ? 'text-warning'
                                        : 'text-danger'
                                        ">
                                        {{
                                          formatCurrency(
                                            y.unitCost * y.quantity
                                          )
                                        }}
                                      </td>
                                      <td class="py-2 align-top text-center">
                                        <div class="badge p-2" :class="y.isDelivered
                                          ? 'bg-success'
                                          : 'bg-danger'
                                          ">
                                          <b class="font-size-12">{{
                                            y.isDelivered
                                              ? "DELIVERED"
                                              : "WAIVED"
                                          }}</b>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                  <tbody>
                                    <tr>
                                      <td class="py-2"></td>
                                      <td class="py-2"></td>
                                      <td class="py-2"></td>
                                      <td class="py-2"></td>
                                      <td class="py-2 text-center font-size-15 text-warning">
                                        {{
                                          formatCurrency(getTotal(x.iarItems))
                                        }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-card-body>
                    </div>
                  </b-collapse>
                </b-card>
              </div>
            </div>
            <div class="row pt-3 pb-3">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="paginate pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
    <!-- Find PO -->
    <transition name="fade">
      <div @mouseenter="mouseOverSearch = true" @mouseleave="mouseOverSearch = false" class="position-fixed"
        style="bottom: 20px; left: 50px">
        <div title="Search PO" class="avatar-sm mx-auto cursor-pointer" @click="searchPo()">
          <span class="avatar-title rounded-circle bg-info">
            <i class="mdi mdi-magnify font-size-24" :class="{
              'bx-tada': mouseOverSearch == true
            }"></i>
          </span>
        </div>
      </div>
    </transition>
    <PoSearch ref="PoSearch"></PoSearch>
    <employee ref="employee" @dropData="dropEmployee($event)"></employee>
    <warehouse ref="warehouse" @dropData="dropWarehouse($event)"></warehouse>
    <item-category @dropData="dropItemCat($event)"></item-category>
    <unit ref="unit" @dropData="dropUnit($event)"></unit>
    <contract ref="contract"></contract>
    <PO ref="po"></PO>
    <print-options ref="printOpt"></print-options>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}

.paginate {
  z-index: -1 !important;
}

.mx-datepicker-sidebar {
  padding: 0;
}

.date-range-selected {
  background: #1284e7;
  color: #fff;
}

.v-enter-active {
  animation: fade-in 0.3s;
}

.v-leave-active {
  animation: fade-in 0.3s reverse;
}

.fade-enter-active {
  animation: fade-in 0.5s;
}

.fade-leave-active {
  animation: fade-in 0.5s reverse;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
